/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { TellerOnlineApiClientBase } from 'teller-online-libraries/core';
import { TellerOnlineWindowService } from "teller-online-libraries/shared";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AuthApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return AuthApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) AuthApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        AuthApiClient._baseUrl = baseUrl;
    }

    /**
     * Sign in
     * @param body (optional) 
     * @return OK
     */
    signIn(body: SignInRequestDto | undefined): Observable<SignInResponseDto> {
        let url_ = this.baseUrl + "/auth/sign-in";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSignIn(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSignIn(<any>r));
                } catch (e) {
                    return <Observable<SignInResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SignInResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processSignIn(response: HttpResponseBase): Observable<SignInResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sign out
     * @return OK
     */
    signOut(): Observable<void> {
        let url_ = this.baseUrl + "/auth/sign-out/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSignOut(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSignOut(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSignOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exend Session
     * @return OK
     */
    extendSession(): Observable<void> {
        let url_ = this.baseUrl + "/auth/extend-session/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processExtendSession(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processExtendSession(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExtendSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current user name
     * @return OK
     */
    currentUser(): Observable<CurrentUserDto> {
        let url_ = this.baseUrl + "/auth/current-user/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCurrentUser(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCurrentUser(<any>r));
                } catch (e) {
                    return <Observable<CurrentUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCurrentUser(response: HttpResponseBase): Observable<CurrentUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get AD Authentication configuration
     * @return OK
     */
    adConfig(): Observable<AdConfigDto> {
        let url_ = this.baseUrl + "/auth/adconfig";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAdConfig(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAdConfig(<any>r));
                } catch (e) {
                    return <Observable<AdConfigDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdConfigDto>><any>_observableThrow(response_);
        }));
    }

    protected processAdConfig(response: HttpResponseBase): Observable<AdConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Teller user info from the REST API wrapper
     * @return OK
     */
    getTellerUserInfo(): Observable<TellerUserInfoDto> {
        let url_ = this.baseUrl + "/auth/teller-user-info";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetTellerUserInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetTellerUserInfo(<any>r));
                } catch (e) {
                    return <Observable<TellerUserInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerUserInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTellerUserInfo(response: HttpResponseBase): Observable<TellerUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate external auth token and redirect to config page
     * @param body (optional) 
     * @return HTML response to close tab on authentication failure
     */
    externalConfigAccess(body: ExternalConfigAccessRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/auth/external-config-access";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "text/html"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processExternalConfigAccess(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processExternalConfigAccess(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processExternalConfigAccess(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Redirect to config page on successful authentication", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return ConfigurationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) ConfigurationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        ConfigurationApiClient._baseUrl = baseUrl;
    }

    /**
     * Get Teller Online plugins grouped by system
     * @param capability (optional) Filters returned plugins to those that satisfy the requested capability. Defaults to BusinessSystemItems (regular search-page integrations) when omitted.
     * @return OK
     */
    getTellerPlugins(capability: TOPluginCapabilityEnumDto | undefined): Observable<TellerPluginsDto> {
        let url_ = this.baseUrl + "/config/teller-plugins?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (capability === null)
            throw new Error("The parameter 'capability' cannot be null.");
        else if (capability !== undefined)
            url_ += "capability=" + encodeURIComponent("" + capability) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetTellerPlugins(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetTellerPlugins(<any>r));
                } catch (e) {
                    return <Observable<TellerPluginsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerPluginsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTellerPlugins(response: HttpResponseBase): Observable<TellerPluginsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerPluginsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Teller item types grouped by system
     * @return Success
     */
    getTellerItemTypes(): Observable<TellerItemTypesDto> {
        let url_ = this.baseUrl + "/config/teller-item-types";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetTellerItemTypes(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetTellerItemTypes(<any>r));
                } catch (e) {
                    return <Observable<TellerItemTypesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerItemTypesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTellerItemTypes(response: HttpResponseBase): Observable<TellerItemTypesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerItemTypesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query inbound redirect sources with optional filtering
     * @param pageId (optional) 
     * @param active (optional) 
     * @return OK
     */
    getInboundRedirectSources(pageId: number | undefined, active: boolean | undefined): Observable<InboundRedirectSourceListResponseDto> {
        let url_ = this.baseUrl + "/config/inbound-redirect-sources?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "pageId=" + encodeURIComponent("" + pageId) + "&";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInboundRedirectSources(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInboundRedirectSources(<any>r));
                } catch (e) {
                    return <Observable<InboundRedirectSourceListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InboundRedirectSourceListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInboundRedirectSources(response: HttpResponseBase): Observable<InboundRedirectSourceListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundRedirectSourceListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new inbound redirect source
     * @param body (optional) 
     * @return OK
     */
    createInboundRedirectSource(body: CreateInboundRedirectSourceDto | undefined): Observable<InboundRedirectSourceDto> {
        let url_ = this.baseUrl + "/config/inbound-redirect-sources";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateInboundRedirectSource(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateInboundRedirectSource(<any>r));
                } catch (e) {
                    return <Observable<InboundRedirectSourceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InboundRedirectSourceDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInboundRedirectSource(response: HttpResponseBase): Observable<InboundRedirectSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundRedirectSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an inbound redirect source by ID
     * @return OK
     */
    getInboundRedirectSourceById(id: number): Observable<InboundRedirectSourceDto> {
        let url_ = this.baseUrl + "/config/inbound-redirect-sources/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInboundRedirectSourceById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInboundRedirectSourceById(<any>r));
                } catch (e) {
                    return <Observable<InboundRedirectSourceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InboundRedirectSourceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInboundRedirectSourceById(response: HttpResponseBase): Observable<InboundRedirectSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundRedirectSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing inbound redirect source
     * @param body (optional) 
     * @return OK
     */
    updateInboundRedirectSource(id: number, body: UpdateInboundRedirectSourceDto | undefined): Observable<InboundRedirectSourceDto> {
        let url_ = this.baseUrl + "/config/inbound-redirect-sources/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateInboundRedirectSource(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateInboundRedirectSource(<any>r));
                } catch (e) {
                    return <Observable<InboundRedirectSourceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InboundRedirectSourceDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateInboundRedirectSource(response: HttpResponseBase): Observable<InboundRedirectSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InboundRedirectSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an inbound redirect source
     * @return No Content
     */
    deleteInboundRedirectSource(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/inbound-redirect-sources/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteInboundRedirectSource(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteInboundRedirectSource(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteInboundRedirectSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query email templates with optional filtering
     * @param publicPortalSiteId (optional) 
     * @param name (optional) 
     * @return OK
     */
    getEmailTemplates(publicPortalSiteId: number | undefined, name: number | undefined): Observable<EmailTemplateListResponseDto> {
        let url_ = this.baseUrl + "/config/email-templates?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (publicPortalSiteId === null)
            throw new Error("The parameter 'publicPortalSiteId' cannot be null.");
        else if (publicPortalSiteId !== undefined)
            url_ += "publicPortalSiteId=" + encodeURIComponent("" + publicPortalSiteId) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEmailTemplates(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEmailTemplates(<any>r));
                } catch (e) {
                    return <Observable<EmailTemplateListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailTemplateListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplates(response: HttpResponseBase): Observable<EmailTemplateListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new email template
     * @param body (optional) 
     * @return OK
     */
    createEmailTemplate(body: CreateEmailTemplateDto | undefined): Observable<EmailTemplateDto> {
        let url_ = this.baseUrl + "/config/email-templates";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateEmailTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateEmailTemplate(<any>r));
                } catch (e) {
                    return <Observable<EmailTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateEmailTemplate(response: HttpResponseBase): Observable<EmailTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an email template by ID
     * @return OK
     */
    getEmailTemplateById(id: number): Observable<EmailTemplateDto> {
        let url_ = this.baseUrl + "/config/email-templates/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEmailTemplateById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEmailTemplateById(<any>r));
                } catch (e) {
                    return <Observable<EmailTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplateById(response: HttpResponseBase): Observable<EmailTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing email template
     * @param body (optional) 
     * @return OK
     */
    updateEmailTemplate(id: number, body: UpdateEmailTemplateDto | undefined): Observable<EmailTemplateDto> {
        let url_ = this.baseUrl + "/config/email-templates/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateEmailTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateEmailTemplate(<any>r));
                } catch (e) {
                    return <Observable<EmailTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEmailTemplate(response: HttpResponseBase): Observable<EmailTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an email template
     * @return No Content
     */
    deleteEmailTemplate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/email-templates/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteEmailTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteEmailTemplate(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEmailTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all available email template name options for dropdown selection
     * @return OK
     */
    getEmailTemplateNameOptions(): Observable<EmailTemplateNameOptionDto[]> {
        let url_ = this.baseUrl + "/config/email-template-name-options";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEmailTemplateNameOptions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEmailTemplateNameOptions(<any>r));
                } catch (e) {
                    return <Observable<EmailTemplateNameOptionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailTemplateNameOptionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplateNameOptions(response: HttpResponseBase): Observable<EmailTemplateNameOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateNameOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query pages with optional filtering
     * @param publicPortalSiteId (optional) 
     * @param tellerConnectionId (optional) 
     * @param active (optional) 
     * @return OK
     */
    getPages(publicPortalSiteId: number | undefined, tellerConnectionId: number | undefined, active: boolean | undefined): Observable<PageListResponseDto> {
        let url_ = this.baseUrl + "/config/pages?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (publicPortalSiteId === null)
            throw new Error("The parameter 'publicPortalSiteId' cannot be null.");
        else if (publicPortalSiteId !== undefined)
            url_ += "publicPortalSiteId=" + encodeURIComponent("" + publicPortalSiteId) + "&";
        if (tellerConnectionId === null)
            throw new Error("The parameter 'tellerConnectionId' cannot be null.");
        else if (tellerConnectionId !== undefined)
            url_ += "tellerConnectionId=" + encodeURIComponent("" + tellerConnectionId) + "&";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPages(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPages(<any>r));
                } catch (e) {
                    return <Observable<PageListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPages(response: HttpResponseBase): Observable<PageListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new page
     * @param body (optional) 
     * @return OK
     */
    createPage(body: CreatePageDto | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/config/pages";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreatePage(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreatePage(<any>r));
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePage(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a page by ID
     * @return OK
     */
    getPageById(id: number): Observable<PageDto> {
        let url_ = this.baseUrl + "/config/pages/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPageById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPageById(<any>r));
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPageById(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing page
     * @param body (optional) 
     * @return OK
     */
    updatePage(id: number, body: UpdatePageDto | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/config/pages/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdatePage(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdatePage(<any>r));
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePage(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a page
     * @return No Content
     */
    deletePage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/pages/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeletePage(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeletePage(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set a page's payment processor config key override
     * @return No Content
     */
    setPagePaymentProcessorConfigKey(id: number, body: SetPaymentProcessorConfigKeyRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/config/pages/{id}/payment-processor-config-key";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetPagePaymentProcessorConfigKey(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetPagePaymentProcessorConfigKey(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetPagePaymentProcessorConfigKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clear a page's payment processor config key override
     * @return No Content
     */
    clearPagePaymentProcessorConfigKey(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/pages/{id}/payment-processor-config-key";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClearPagePaymentProcessorConfigKey(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClearPagePaymentProcessorConfigKey(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearPagePaymentProcessorConfigKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query page item types with optional filtering
     * @param pageId (optional) 
     * @param active (optional) 
     * @return OK
     */
    getPageItemTypes(pageId: number | undefined, active: boolean | undefined): Observable<PageItemTypeListResponseDto> {
        let url_ = this.baseUrl + "/config/page-item-types?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "pageId=" + encodeURIComponent("" + pageId) + "&";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPageItemTypes(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPageItemTypes(<any>r));
                } catch (e) {
                    return <Observable<PageItemTypeListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageItemTypeListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPageItemTypes(response: HttpResponseBase): Observable<PageItemTypeListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageItemTypeListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new page item type
     * @param body (optional) 
     * @return OK
     */
    createPageItemType(body: CreatePageItemTypeDto | undefined): Observable<PageItemTypeDto> {
        let url_ = this.baseUrl + "/config/page-item-types";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreatePageItemType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreatePageItemType(<any>r));
                } catch (e) {
                    return <Observable<PageItemTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageItemTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePageItemType(response: HttpResponseBase): Observable<PageItemTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageItemTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a page item type by ID
     * @return OK
     */
    getPageItemTypeById(id: number): Observable<PageItemTypeDto> {
        let url_ = this.baseUrl + "/config/page-item-types/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPageItemTypeById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPageItemTypeById(<any>r));
                } catch (e) {
                    return <Observable<PageItemTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageItemTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPageItemTypeById(response: HttpResponseBase): Observable<PageItemTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageItemTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing page item type
     * @param body (optional) 
     * @return OK
     */
    updatePageItemType(id: number, body: UpdatePageItemTypeDto | undefined): Observable<PageItemTypeDto> {
        let url_ = this.baseUrl + "/config/page-item-types/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdatePageItemType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdatePageItemType(<any>r));
                } catch (e) {
                    return <Observable<PageItemTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageItemTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePageItemType(response: HttpResponseBase): Observable<PageItemTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageItemTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a page item type
     * @return No Content
     */
    deletePageItemType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/page-item-types/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeletePageItemType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeletePageItemType(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePageItemType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query portal features with optional filtering
     * @param publicPortalSiteId (optional) 
     * @param enabled (optional) 
     * @return OK
     */
    getPortalFeatures(publicPortalSiteId: number | undefined, enabled: boolean | undefined): Observable<ConfigPortalFeatureListResponseDto> {
        let url_ = this.baseUrl + "/config/portal-features?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (publicPortalSiteId === null)
            throw new Error("The parameter 'publicPortalSiteId' cannot be null.");
        else if (publicPortalSiteId !== undefined)
            url_ += "publicPortalSiteId=" + encodeURIComponent("" + publicPortalSiteId) + "&";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPortalFeatures(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPortalFeatures(<any>r));
                } catch (e) {
                    return <Observable<ConfigPortalFeatureListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigPortalFeatureListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPortalFeatures(response: HttpResponseBase): Observable<ConfigPortalFeatureListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigPortalFeatureListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new portal feature
     * @param body (optional) 
     * @return OK
     */
    createPortalFeature(body: CreateConfigPortalFeatureDto | undefined): Observable<ConfigPortalFeatureDto> {
        let url_ = this.baseUrl + "/config/portal-features";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreatePortalFeature(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreatePortalFeature(<any>r));
                } catch (e) {
                    return <Observable<ConfigPortalFeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigPortalFeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePortalFeature(response: HttpResponseBase): Observable<ConfigPortalFeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigPortalFeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a portal feature by ID
     * @return OK
     */
    getPortalFeatureById(id: number): Observable<ConfigPortalFeatureDto> {
        let url_ = this.baseUrl + "/config/portal-features/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPortalFeatureById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPortalFeatureById(<any>r));
                } catch (e) {
                    return <Observable<ConfigPortalFeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigPortalFeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPortalFeatureById(response: HttpResponseBase): Observable<ConfigPortalFeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigPortalFeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing portal feature
     * @param body (optional) 
     * @return OK
     */
    updatePortalFeature(id: number, body: UpdateConfigPortalFeatureDto | undefined): Observable<ConfigPortalFeatureDto> {
        let url_ = this.baseUrl + "/config/portal-features/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdatePortalFeature(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdatePortalFeature(<any>r));
                } catch (e) {
                    return <Observable<ConfigPortalFeatureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigPortalFeatureDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePortalFeature(response: HttpResponseBase): Observable<ConfigPortalFeatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigPortalFeatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a portal feature
     * @return No Content
     */
    deletePortalFeature(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/portal-features/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeletePortalFeature(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeletePortalFeature(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePortalFeature(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query public portal sites with optional filtering
     * @param tenantName (optional) 
     * @return OK
     */
    getPublicPortalSites(tenantName: string | undefined): Observable<PublicPortalSiteListResponseDto> {
        let url_ = this.baseUrl + "/config/public-portal-sites?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (tenantName === null)
            throw new Error("The parameter 'tenantName' cannot be null.");
        else if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicPortalSites(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicPortalSites(<any>r));
                } catch (e) {
                    return <Observable<PublicPortalSiteListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublicPortalSiteListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicPortalSites(response: HttpResponseBase): Observable<PublicPortalSiteListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicPortalSiteListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new public portal site
     * @param body (optional) 
     * @return OK
     */
    createPublicPortalSite(body: CreatePublicPortalSiteDto | undefined): Observable<PublicPortalSiteDto> {
        let url_ = this.baseUrl + "/config/public-portal-sites";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreatePublicPortalSite(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreatePublicPortalSite(<any>r));
                } catch (e) {
                    return <Observable<PublicPortalSiteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublicPortalSiteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePublicPortalSite(response: HttpResponseBase): Observable<PublicPortalSiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicPortalSiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a public portal site by ID
     * @return OK
     */
    getPublicPortalSiteById(id: number): Observable<PublicPortalSiteDto> {
        let url_ = this.baseUrl + "/config/public-portal-sites/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicPortalSiteById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicPortalSiteById(<any>r));
                } catch (e) {
                    return <Observable<PublicPortalSiteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublicPortalSiteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicPortalSiteById(response: HttpResponseBase): Observable<PublicPortalSiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicPortalSiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing public portal site
     * @param body (optional) 
     * @return OK
     */
    updatePublicPortalSite(id: number, body: UpdatePublicPortalSiteDto | undefined): Observable<PublicPortalSiteDto> {
        let url_ = this.baseUrl + "/config/public-portal-sites/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdatePublicPortalSite(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdatePublicPortalSite(<any>r));
                } catch (e) {
                    return <Observable<PublicPortalSiteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublicPortalSiteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePublicPortalSite(response: HttpResponseBase): Observable<PublicPortalSiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicPortalSiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a public portal site
     * @return No Content
     */
    deletePublicPortalSite(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/public-portal-sites/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeletePublicPortalSite(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeletePublicPortalSite(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePublicPortalSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Bulk upload tenant branding assets (logo, favicon, styles)
     * @param logo (optional) Optional logo.png file
     * @param favicon (optional) Optional favicon.ico file
     * @param styles (optional) Optional styles.css file
     * @return OK
     */
    uploadAssets(id: number, logo: FileParameter | undefined, favicon: FileParameter | undefined, styles: FileParameter | undefined): Observable<BulkAssetUploadResultDto> {
        let url_ = this.baseUrl + "/config/public-portal-sites/{id}/assets";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logo === null || logo === undefined)
            throw new Error("The parameter 'logo' cannot be null.");
        else
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");
        if (favicon === null || favicon === undefined)
            throw new Error("The parameter 'favicon' cannot be null.");
        else
            content_.append("favicon", favicon.data, favicon.fileName ? favicon.fileName : "favicon");
        if (styles === null || styles === undefined)
            throw new Error("The parameter 'styles' cannot be null.");
        else
            content_.append("styles", styles.data, styles.fileName ? styles.fileName : "styles");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUploadAssets(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUploadAssets(<any>r));
                } catch (e) {
                    return <Observable<BulkAssetUploadResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BulkAssetUploadResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadAssets(response: HttpResponseBase): Observable<BulkAssetUploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BulkAssetUploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get URLs for all tenant branding assets
     * @return OK
     */
    getAllAssets(id: number): Observable<AllAssetsDto> {
        let url_ = this.baseUrl + "/config/public-portal-sites/{id}/assets";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllAssets(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllAssets(<any>r));
                } catch (e) {
                    return <Observable<AllAssetsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllAssetsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAssets(response: HttpResponseBase): Observable<AllAssetsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllAssetsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query SMS templates with optional filtering
     * @param publicPortalSiteId (optional) 
     * @param name (optional) 
     * @return OK
     */
    getSMSTemplates(publicPortalSiteId: number | undefined, name: number | undefined): Observable<SMSTemplateListResponseDto> {
        let url_ = this.baseUrl + "/config/sms-templates?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (publicPortalSiteId === null)
            throw new Error("The parameter 'publicPortalSiteId' cannot be null.");
        else if (publicPortalSiteId !== undefined)
            url_ += "publicPortalSiteId=" + encodeURIComponent("" + publicPortalSiteId) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSMSTemplates(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSMSTemplates(<any>r));
                } catch (e) {
                    return <Observable<SMSTemplateListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMSTemplateListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSMSTemplates(response: HttpResponseBase): Observable<SMSTemplateListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSTemplateListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new SMS template
     * @param body (optional) 
     * @return OK
     */
    createSMSTemplate(body: CreateSMSTemplateDto | undefined): Observable<SMSTemplateDto> {
        let url_ = this.baseUrl + "/config/sms-templates";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateSMSTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateSMSTemplate(<any>r));
                } catch (e) {
                    return <Observable<SMSTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMSTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSMSTemplate(response: HttpResponseBase): Observable<SMSTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an SMS template by ID
     * @return OK
     */
    getSMSTemplateById(id: number): Observable<SMSTemplateDto> {
        let url_ = this.baseUrl + "/config/sms-templates/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSMSTemplateById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSMSTemplateById(<any>r));
                } catch (e) {
                    return <Observable<SMSTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMSTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSMSTemplateById(response: HttpResponseBase): Observable<SMSTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing SMS template
     * @param body (optional) 
     * @return OK
     */
    updateSMSTemplate(id: number, body: UpdateSMSTemplateDto | undefined): Observable<SMSTemplateDto> {
        let url_ = this.baseUrl + "/config/sms-templates/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateSMSTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateSMSTemplate(<any>r));
                } catch (e) {
                    return <Observable<SMSTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMSTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSMSTemplate(response: HttpResponseBase): Observable<SMSTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMSTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an SMS template
     * @return No Content
     */
    deleteSMSTemplate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/sms-templates/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteSMSTemplate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteSMSTemplate(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSMSTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all available SMS template name options for dropdown selection
     * @return OK
     */
    getSMSTemplateNameOptions(): Observable<SMSTemplateNameOptionDto[]> {
        let url_ = this.baseUrl + "/config/sms-template-name-options";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSMSTemplateNameOptions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSMSTemplateNameOptions(<any>r));
                } catch (e) {
                    return <Observable<SMSTemplateNameOptionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SMSTemplateNameOptionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSMSTemplateNameOptions(response: HttpResponseBase): Observable<SMSTemplateNameOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMSTemplateNameOptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query search types with optional filtering
     * @param pageId (optional) 
     * @param active (optional) 
     * @return OK
     */
    getSearchTypes(pageId: number | undefined, active: boolean | undefined): Observable<SearchTypeListResponseDto> {
        let url_ = this.baseUrl + "/config/search-types?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "pageId=" + encodeURIComponent("" + pageId) + "&";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSearchTypes(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSearchTypes(<any>r));
                } catch (e) {
                    return <Observable<SearchTypeListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchTypeListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchTypes(response: HttpResponseBase): Observable<SearchTypeListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTypeListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new search type
     * @param body (optional) 
     * @return OK
     */
    createSearchType(body: CreateSearchTypeDto | undefined): Observable<SearchTypeDto> {
        let url_ = this.baseUrl + "/config/search-types";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateSearchType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateSearchType(<any>r));
                } catch (e) {
                    return <Observable<SearchTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSearchType(response: HttpResponseBase): Observable<SearchTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a search type by ID
     * @return OK
     */
    getSearchTypeById(id: number): Observable<SearchTypeDto> {
        let url_ = this.baseUrl + "/config/search-types/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSearchTypeById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSearchTypeById(<any>r));
                } catch (e) {
                    return <Observable<SearchTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchTypeById(response: HttpResponseBase): Observable<SearchTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing search type
     * @param body (optional) 
     * @return OK
     */
    updateSearchType(id: number, body: UpdateSearchTypeDto | undefined): Observable<SearchTypeDto> {
        let url_ = this.baseUrl + "/config/search-types/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateSearchType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateSearchType(<any>r));
                } catch (e) {
                    return <Observable<SearchTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSearchType(response: HttpResponseBase): Observable<SearchTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a search type
     * @return No Content
     */
    deleteSearchType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/search-types/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteSearchType(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteSearchType(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSearchType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query teller connections with optional filtering
     * @param publicPortalSiteId (optional) 
     * @return OK
     */
    getTellerConnections(publicPortalSiteId: number | undefined): Observable<TellerConnectionListResponseDto> {
        let url_ = this.baseUrl + "/config/teller-connections?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (publicPortalSiteId === null)
            throw new Error("The parameter 'publicPortalSiteId' cannot be null.");
        else if (publicPortalSiteId !== undefined)
            url_ += "publicPortalSiteId=" + encodeURIComponent("" + publicPortalSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetTellerConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetTellerConnections(<any>r));
                } catch (e) {
                    return <Observable<TellerConnectionListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerConnectionListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTellerConnections(response: HttpResponseBase): Observable<TellerConnectionListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerConnectionListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new teller connection
     * @param body (optional) 
     * @return OK
     */
    createTellerConnection(body: TellerConnectionDto | undefined): Observable<TellerConnectionDto> {
        let url_ = this.baseUrl + "/config/teller-connections";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateTellerConnection(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateTellerConnection(<any>r));
                } catch (e) {
                    return <Observable<TellerConnectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerConnectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTellerConnection(response: HttpResponseBase): Observable<TellerConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a teller connection by ID
     * @return OK
     */
    getTellerConnectionById(id: number): Observable<TellerConnectionDto> {
        let url_ = this.baseUrl + "/config/teller-connections/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetTellerConnectionById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetTellerConnectionById(<any>r));
                } catch (e) {
                    return <Observable<TellerConnectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerConnectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTellerConnectionById(response: HttpResponseBase): Observable<TellerConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing teller connection
     * @param body (optional) 
     * @return OK
     */
    updateTellerConnection(id: number, body: TellerConnectionDto | undefined): Observable<TellerConnectionDto> {
        let url_ = this.baseUrl + "/config/teller-connections/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateTellerConnection(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateTellerConnection(<any>r));
                } catch (e) {
                    return <Observable<TellerConnectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TellerConnectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTellerConnection(response: HttpResponseBase): Observable<TellerConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TellerConnectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a teller connection
     * @return No Content
     */
    deleteTellerConnection(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/teller-connections/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteTellerConnection(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteTellerConnection(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTellerConnection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set a teller connection's payment processor config key
     * @return No Content
     */
    setTellerConnectionPaymentProcessorConfigKey(id: number, body: SetPaymentProcessorConfigKeyRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/config/teller-connections/{id}/payment-processor-config-key";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetTellerConnectionPaymentProcessorConfigKey(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetTellerConnectionPaymentProcessorConfigKey(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetTellerConnectionPaymentProcessorConfigKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Clear a teller connection's payment processor config key
     * @return No Content
     */
    clearTellerConnectionPaymentProcessorConfigKey(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/teller-connections/{id}/payment-processor-config-key";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClearTellerConnectionPaymentProcessorConfigKey(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClearTellerConnectionPaymentProcessorConfigKey(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearTellerConnectionPaymentProcessorConfigKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get TellerApiUser permission status per system
     * @return OK
     */
    getApiUserPermissions(): Observable<ApiUserPermissionsResultDto> {
        let url_ = this.baseUrl + "/config/api-user-permissions";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetApiUserPermissions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetApiUserPermissions(<any>r));
                } catch (e) {
                    return <Observable<ApiUserPermissionsResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiUserPermissionsResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetApiUserPermissions(response: HttpResponseBase): Observable<ApiUserPermissionsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserPermissionsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Query menu items with optional filtering
     * @param publicPortalSiteId (optional) 
     * @param pageId (optional) 
     * @param active (optional) 
     * @return OK
     */
    getMenuItems(publicPortalSiteId: number | undefined, pageId: number | undefined, active: boolean | undefined): Observable<ConfigMenuItemListResponseDto> {
        let url_ = this.baseUrl + "/config/menu-items?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (publicPortalSiteId === null)
            throw new Error("The parameter 'publicPortalSiteId' cannot be null.");
        else if (publicPortalSiteId !== undefined)
            url_ += "publicPortalSiteId=" + encodeURIComponent("" + publicPortalSiteId) + "&";
        if (pageId === null)
            throw new Error("The parameter 'pageId' cannot be null.");
        else if (pageId !== undefined)
            url_ += "pageId=" + encodeURIComponent("" + pageId) + "&";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMenuItems(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMenuItems(<any>r));
                } catch (e) {
                    return <Observable<ConfigMenuItemListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigMenuItemListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenuItems(response: HttpResponseBase): Observable<ConfigMenuItemListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigMenuItemListResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new menu item
     * @param body (optional) 
     * @return OK
     */
    createMenuItem(body: CreateConfigMenuItemDto | undefined): Observable<ConfigMenuItemDto> {
        let url_ = this.baseUrl + "/config/menu-items";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateMenuItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateMenuItem(<any>r));
                } catch (e) {
                    return <Observable<ConfigMenuItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigMenuItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMenuItem(response: HttpResponseBase): Observable<ConfigMenuItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigMenuItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a menu item by ID
     * @return OK
     */
    getMenuItemById(id: number): Observable<ConfigMenuItemDto> {
        let url_ = this.baseUrl + "/config/menu-items/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMenuItemById(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMenuItemById(<any>r));
                } catch (e) {
                    return <Observable<ConfigMenuItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigMenuItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMenuItemById(response: HttpResponseBase): Observable<ConfigMenuItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigMenuItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing menu item
     * @param body (optional) 
     * @return OK
     */
    updateMenuItem(id: number, body: UpdateConfigMenuItemDto | undefined): Observable<ConfigMenuItemDto> {
        let url_ = this.baseUrl + "/config/menu-items/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateMenuItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateMenuItem(<any>r));
                } catch (e) {
                    return <Observable<ConfigMenuItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigMenuItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMenuItem(response: HttpResponseBase): Observable<ConfigMenuItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigMenuItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a menu item
     * @return No Content
     */
    deleteMenuItem(id: number): Observable<void> {
        let url_ = this.baseUrl + "/config/menu-items/{id}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteMenuItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteMenuItem(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMenuItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reorder menu items by updating their display order values
     * @return OK
     */
    reorderMenuItems(body: ReorderMenuItemsRequestDto): Observable<ConfigMenuItemDto[]> {
        let url_ = this.baseUrl + "/config/menu-items/reorder";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processReorderMenuItems(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReorderMenuItems(<any>r));
                } catch (e) {
                    return <Observable<ConfigMenuItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConfigMenuItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processReorderMenuItems(response: HttpResponseBase): Observable<ConfigMenuItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfigMenuItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminPaymentsApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return AdminPaymentsApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) AdminPaymentsApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        AdminPaymentsApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve a list of all payments, optionally filtered by passed in options
     * @param body (optional) 
     * @return OK
     */
    getFilteredPayments(body: SearchSettingsDto | undefined): Observable<FilteredPaymentsResponseDto> {
        let url_ = this.baseUrl + "/admin-payments/filtered";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetFilteredPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetFilteredPayments(<any>r));
                } catch (e) {
                    return <Observable<FilteredPaymentsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredPaymentsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilteredPayments(response: HttpResponseBase): Observable<FilteredPaymentsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredPaymentsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve upcoming scheduled payment instances, optionally filtered
     * @param body (optional) 
     * @return OK
     */
    getUpcomingPayments(body: SearchSettingsDto | undefined): Observable<FilteredPaymentsResponseDto> {
        let url_ = this.baseUrl + "/admin-payments/upcoming";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUpcomingPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUpcomingPayments(<any>r));
                } catch (e) {
                    return <Observable<FilteredPaymentsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredPaymentsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpcomingPayments(response: HttpResponseBase): Observable<FilteredPaymentsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredPaymentsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve information about what admin actions are available for a payment
     * @param paymentIdentifier Unique identifier for the payment.
     * @return OK
     */
    getPaymentAdminStatus(paymentIdentifier: string): Observable<PaymentAdminDetailsDto> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/admin-status/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPaymentAdminStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPaymentAdminStatus(<any>r));
                } catch (e) {
                    return <Observable<PaymentAdminDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentAdminDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentAdminStatus(response: HttpResponseBase): Observable<PaymentAdminDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentAdminDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the list of events for this payment
     * @param body (optional) 
     * @param paymentIdentifier Unique identifier for the payment.
     * @return OK
     */
    getPaymentActivity(body: SearchSettingsDto | undefined, paymentIdentifier: string): Observable<FilteredPaymentActivityResponseDto> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/activity/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPaymentActivity(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPaymentActivity(<any>r));
                } catch (e) {
                    return <Observable<FilteredPaymentActivityResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredPaymentActivityResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentActivity(response: HttpResponseBase): Observable<FilteredPaymentActivityResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredPaymentActivityResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the list of cart events correlated to this scheduled payment instance.
     * @param body (optional) 
     * @param scheduledPaymentInstanceGuid Unique identifier (Guid) for the scheduled payment instance.
     * @return OK
     */
    getScheduledPaymentActivity(body: SearchSettingsDto | undefined, scheduledPaymentInstanceGuid: string): Observable<FilteredPaymentActivityResponseDto> {
        let url_ = this.baseUrl + "/admin-payments/scheduled-payment/{ScheduledPaymentInstanceGuid}/activity/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (scheduledPaymentInstanceGuid === undefined || scheduledPaymentInstanceGuid === null)
            throw new Error("The parameter 'scheduledPaymentInstanceGuid' must be defined.");
        url_ = url_.replace("{ScheduledPaymentInstanceGuid}", encodeURIComponent("" + scheduledPaymentInstanceGuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentActivity(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentActivity(<any>r));
                } catch (e) {
                    return <Observable<FilteredPaymentActivityResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredPaymentActivityResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduledPaymentActivity(response: HttpResponseBase): Observable<FilteredPaymentActivityResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredPaymentActivityResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the Payment Identifier for the next/previous payments based on saved filter/sort settings
     * @param paymentIdentifier Unique identifier for the payment.
     * @param body (optional) 
     * @return OK
     */
    getNextPrevPayments(paymentIdentifier: string, body: SearchSettingsDto | undefined): Observable<PaymentsNextPrevDto> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/next-prev/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetNextPrevPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetNextPrevPayments(<any>r));
                } catch (e) {
                    return <Observable<PaymentsNextPrevDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentsNextPrevDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNextPrevPayments(response: HttpResponseBase): Observable<PaymentsNextPrevDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentsNextPrevDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sync payment with Teller by attempting to repost it and handling the response
     * @param paymentIdentifier Unique identifier for the payment.
     * @return OK
     */
    syncPaymentWithTeller(paymentIdentifier: string): Observable<void> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/sync-payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSyncPaymentWithTeller(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSyncPaymentWithTeller(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSyncPaymentWithTeller(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Mark payment as cancelled so that it won't retry within Teller - only available if payment is not saved
     * @param paymentIdentifier Unique identifier for the payment.
     * @param body (optional) 
     * @return OK
     */
    cancelPayment(paymentIdentifier: string, body: CancelPaymentRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/cancel-payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCancelPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCancelPayment(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset payment status to processing so that it will be picked up again
     * @param paymentIdentifier Unique identifier for the payment.
     * @param body (optional) 
     * @return OK
     */
    retryPayment(paymentIdentifier: string, body: RetryPaymentRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/retry-payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRetryPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRetryPayment(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRetryPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks a payment as having been refunded in the payment processor
     * @param paymentIdentifier Unique GUID of cart
     * @param body (optional) 
     * @return OK
     */
    markPaymentRefunded(paymentIdentifier: string, body: RefundPaymentRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/refund-payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMarkPaymentRefunded(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMarkPaymentRefunded(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkPaymentRefunded(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the scheduled payment associated with a payment, if one exists
     * @param paymentIdentifier Unique identifier of the payment
     * @return OK. Response body is null when no schedule is associated with the payment.
     */
    getScheduledPaymentByPaymentIdentifier(paymentIdentifier: string): Observable<AdminScheduledPaymentDetailDto | null> {
        let url_ = this.baseUrl + "/admin-payments/{PaymentIdentifier}/scheduled-payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentIdentifier === undefined || paymentIdentifier === null)
            throw new Error("The parameter 'paymentIdentifier' must be defined.");
        url_ = url_.replace("{PaymentIdentifier}", encodeURIComponent("" + paymentIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentByPaymentIdentifier(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentByPaymentIdentifier(<any>r));
                } catch (e) {
                    return <Observable<AdminScheduledPaymentDetailDto | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminScheduledPaymentDetailDto | null>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduledPaymentByPaymentIdentifier(response: HttpResponseBase): Observable<AdminScheduledPaymentDetailDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AdminScheduledPaymentDetailDto.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminUsersApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return AdminUsersApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) AdminUsersApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        AdminUsersApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieves a few simple details describing the history of the user
     * @param userId Unique ID of user
     * @return OK
     */
    getBasicUserHistory(userId: number): Observable<BasicUserHistoryDto> {
        let url_ = this.baseUrl + "/admin-users/{UserId}/basic-history";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetBasicUserHistory(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetBasicUserHistory(<any>r));
                } catch (e) {
                    return <Observable<BasicUserHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BasicUserHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBasicUserHistory(response: HttpResponseBase): Observable<BasicUserHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicUserHistoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of all users, optionally filtered by passed in options
     * @param body (optional) 
     * @return OK
     */
    getFilteredUsers(body: SearchSettingsDto | undefined): Observable<FilteredUsersResponseDto> {
        let url_ = this.baseUrl + "/admin-users/filtered";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetFilteredUsers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetFilteredUsers(<any>r));
                } catch (e) {
                    return <Observable<FilteredUsersResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredUsersResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilteredUsers(response: HttpResponseBase): Observable<FilteredUsersResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredUsersResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a list of all unconfirmed users
     * @param body (optional) 
     * @return OK
     */
    getFilteredUnconfirmedUsers(body: SearchSettingsDto | undefined): Observable<FilteredUnconfirmedUsersResponseDto> {
        let url_ = this.baseUrl + "/admin-users/unconfirmed";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetFilteredUnconfirmedUsers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetFilteredUnconfirmedUsers(<any>r));
                } catch (e) {
                    return <Observable<FilteredUnconfirmedUsersResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredUnconfirmedUsersResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilteredUnconfirmedUsers(response: HttpResponseBase): Observable<FilteredUnconfirmedUsersResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredUnconfirmedUsersResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Count of anonymous users in the portal
     * @return OK
     */
    getAnonymousUsersCount(): Observable<number> {
        let url_ = this.baseUrl + "/admin-users/anonymous-count";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAnonymousUsersCount(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAnonymousUsersCount(<any>r));
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnonymousUsersCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Count of stale admin users
     * @return OK
     */
    getStaleUsers(): Observable<FilteredUsersResponseDto> {
        let url_ = this.baseUrl + "/admin-users/stale";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetStaleUsers(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetStaleUsers(<any>r));
                } catch (e) {
                    return <Observable<FilteredUsersResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredUsersResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStaleUsers(response: HttpResponseBase): Observable<FilteredUsersResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredUsersResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return UserApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) UserApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        UserApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve users payments
     * @param userId Unique ID of user
     * @return OK
     */
    getUserPayments(userId: number): Observable<UserPaymentsDto[]> {
        let url_ = this.baseUrl + "/user/{UserId}/payments";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserPayments(<any>r));
                } catch (e) {
                    return <Observable<UserPaymentsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPaymentsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPayments(response: HttpResponseBase): Observable<UserPaymentsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPaymentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user activity changes history
     * @param userId Unique ID of user
     * @return OK
     */
    getUserActivityHistory(userId: number): Observable<UserActivityHistoryDto[]> {
        let url_ = this.baseUrl + "/user/{UserId}/activities";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserActivityHistory(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserActivityHistory(<any>r));
                } catch (e) {
                    return <Observable<UserActivityHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActivityHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserActivityHistory(response: HttpResponseBase): Observable<UserActivityHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivityHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user activity changes history
     * @param userId Unique ID of user
     * @return OK
     */
    getUserNotificationHistory(userId: number): Observable<UserNotificationHistoryDto[]> {
        let url_ = this.baseUrl + "/user/{UserId}/notifications";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserNotificationHistory(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserNotificationHistory(<any>r));
                } catch (e) {
                    return <Observable<UserNotificationHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotificationHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotificationHistory(response: HttpResponseBase): Observable<UserNotificationHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNotificationHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminScheduledPaymentsApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return AdminScheduledPaymentsApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) AdminScheduledPaymentsApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        AdminScheduledPaymentsApiClient._baseUrl = baseUrl;
    }

    /**
     * Retrieve a list of all scheduled payments, optionally filtered by passed in options
     * @param body (optional) 
     * @return OK
     */
    getFilteredScheduledPayments(body: SearchSettingsDto | undefined): Observable<FilteredScheduledPaymentsResponseDto> {
        let url_ = this.baseUrl + "/admin-scheduled-payments/filtered";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetFilteredScheduledPayments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetFilteredScheduledPayments(<any>r));
                } catch (e) {
                    return <Observable<FilteredScheduledPaymentsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FilteredScheduledPaymentsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilteredScheduledPayments(response: HttpResponseBase): Observable<FilteredScheduledPaymentsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilteredScheduledPaymentsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve details of a scheduled payment by GUID
     * @param guid Unique GUID of the scheduled payment
     * @return OK
     */
    getScheduledPaymentDetail(guid: string): Observable<AdminScheduledPaymentDetailDto> {
        let url_ = this.baseUrl + "/admin-scheduled-payments/{Guid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{Guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentDetail(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentDetail(<any>r));
                } catch (e) {
                    return <Observable<AdminScheduledPaymentDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminScheduledPaymentDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduledPaymentDetail(response: HttpResponseBase): Observable<AdminScheduledPaymentDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminScheduledPaymentDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve schedule details by scheduled payment instance GUID
     * @param instanceGuid Unique GUID of the scheduled payment instance
     * @return OK
     */
    getScheduledPaymentByInstanceGuid(instanceGuid: string): Observable<AdminScheduledPaymentDetailDto> {
        let url_ = this.baseUrl + "/admin-scheduled-payments/instance/{InstanceGuid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (instanceGuid === undefined || instanceGuid === null)
            throw new Error("The parameter 'instanceGuid' must be defined.");
        url_ = url_.replace("{InstanceGuid}", encodeURIComponent("" + instanceGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentByInstanceGuid(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentByInstanceGuid(<any>r));
                } catch (e) {
                    return <Observable<AdminScheduledPaymentDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdminScheduledPaymentDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduledPaymentByInstanceGuid(response: HttpResponseBase): Observable<AdminScheduledPaymentDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminScheduledPaymentDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve the next/previous upcoming instance GUIDs based on saved filter/sort settings
     * @param instanceGuid Unique GUID of the scheduled payment instance
     * @param body (optional) 
     * @return OK
     */
    getNextPrevByInstanceGuid(instanceGuid: string, body: SearchSettingsDto | undefined): Observable<PaymentsNextPrevDto> {
        let url_ = this.baseUrl + "/admin-scheduled-payments/instance/{InstanceGuid}/next-prev/";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (instanceGuid === undefined || instanceGuid === null)
            throw new Error("The parameter 'instanceGuid' must be defined.");
        url_ = url_.replace("{InstanceGuid}", encodeURIComponent("" + instanceGuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetNextPrevByInstanceGuid(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetNextPrevByInstanceGuid(<any>r));
                } catch (e) {
                    return <Observable<PaymentsNextPrevDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentsNextPrevDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNextPrevByInstanceGuid(response: HttpResponseBase): Observable<PaymentsNextPrevDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentsNextPrevDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel a scheduled payment
     * @param guid Unique GUID of the scheduled payment
     * @param body (optional) 
     * @return No Content
     */
    cancelScheduledPayment(guid: string, body: CancelScheduledPaymentRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/admin-scheduled-payments/{Guid}/cancel";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{Guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCancelScheduledPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCancelScheduledPayment(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelScheduledPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get cancellation reasons for a scheduled payment
     * @param guid Unique GUID of the scheduled payment
     * @return OK
     */
    getScheduledPaymentCancellationReasons(guid: string): Observable<string[]> {
        let url_ = this.baseUrl + "/admin-scheduled-payments/{Guid}/cancellation-reasons";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{Guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentCancellationReasons(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledPaymentCancellationReasons(<any>r));
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetScheduledPaymentCancellationReasons(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthorizationTextApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return AuthorizationTextApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) AuthorizationTextApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/admin-portal";
    }

    static init(baseUrl: string){
        AuthorizationTextApiClient._baseUrl = baseUrl;
    }

    /**
     * List all currently-active authorization text versions for the current tenant
     * @return OK
     */
    listActiveAuthorizationTexts(): Observable<AuthorizationTextVersionDto[]> {
        let url_ = this.baseUrl + "/authorization-text";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processListActiveAuthorizationTexts(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processListActiveAuthorizationTexts(<any>r));
                } catch (e) {
                    return <Observable<AuthorizationTextVersionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationTextVersionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processListActiveAuthorizationTexts(response: HttpResponseBase): Observable<AuthorizationTextVersionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizationTextVersionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new authorization text version (deactivates the prior active version)
     * @return OK
     */
    createAuthorizationTextVersion(body: CreateAuthorizationTextVersionRequestDto): Observable<AuthorizationTextVersionDto> {
        let url_ = this.baseUrl + "/authorization-text";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateAuthorizationTextVersion(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateAuthorizationTextVersion(<any>r));
                } catch (e) {
                    return <Observable<AuthorizationTextVersionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationTextVersionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAuthorizationTextVersion(response: HttpResponseBase): Observable<AuthorizationTextVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationTextVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Full version history (active + historical) for one authorization-text variant
     * @return OK
     */
    getAuthorizationTextHistory(paymentMethodType: PaymentTypeEnumDto, authorizationType: PaymentAuthorizationTypeEnumDto): Observable<AuthorizationTextVersionDto[]> {
        let url_ = this.baseUrl + "/authorization-text/{paymentMethodType}/{authorizationType}/history";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{paymentMethodType}", encodeURIComponent("" + paymentMethodType));
        if (authorizationType === undefined || authorizationType === null)
            throw new Error("The parameter 'authorizationType' must be defined.");
        url_ = url_.replace("{authorizationType}", encodeURIComponent("" + authorizationType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAuthorizationTextHistory(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAuthorizationTextHistory(<any>r));
                } catch (e) {
                    return <Observable<AuthorizationTextVersionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationTextVersionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuthorizationTextHistory(response: HttpResponseBase): Observable<AuthorizationTextVersionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizationTextVersionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate a Credit-card authorization text version (rejected for ECheck)
     * @return No Content
     */
    deactivateAuthorizationTextVersion(versionId: number): Observable<void> {
        let url_ = this.baseUrl + "/authorization-text/{versionId}/deactivate";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeactivateAuthorizationTextVersion(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeactivateAuthorizationTextVersion(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeactivateAuthorizationTextVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ExternalConfigAccessRequestDto implements IExternalConfigAccessRequestDto {
    /** The full auth token from Teller for validation */
    authToken!: string;

    [key: string]: any;

    constructor(data?: IExternalConfigAccessRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.authToken = _data["authToken"];
        }
    }

    static fromJS(data: any): ExternalConfigAccessRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalConfigAccessRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["authToken"] = this.authToken;
        return data;
    }
}

export interface IExternalConfigAccessRequestDto {
    /** The full auth token from Teller for validation */
    authToken: string;

    [key: string]: any;
}

export class SignInRequestDto implements ISignInRequestDto {
    /** name of user */
    userId!: string;
    /** Password of user */
    password!: string;

    [key: string]: any;

    constructor(data?: ISignInRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SignInRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }
}

export interface ISignInRequestDto {
    /** name of user */
    userId: string;
    /** Password of user */
    password: string;

    [key: string]: any;
}

export class SignInResponseDto implements ISignInResponseDto {
    /** Did the request succeed? */
    success!: boolean;
    /** Token */
    token!: string;

    [key: string]: any;

    constructor(data?: ISignInResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignInResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignInResponseDto {
    /** Did the request succeed? */
    success: boolean;
    /** Token */
    token: string;

    [key: string]: any;
}

export class AdConfigDto implements IAdConfigDto {
    /** Is AD Enabled for this Tenant? */
    isAdEnabled?: boolean;
    /** URL for 3rd party discovery document */
    issuerUrl?: string;
    /** URL for 3rd party logout endpoint */
    logoutUrl?: string;
    /** 3rd party provided client id */
    clientId?: string;

    [key: string]: any;

    constructor(data?: IAdConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isAdEnabled = _data["isAdEnabled"];
            this.issuerUrl = _data["issuerUrl"];
            this.logoutUrl = _data["logoutUrl"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): AdConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isAdEnabled"] = this.isAdEnabled;
        data["issuerUrl"] = this.issuerUrl;
        data["logoutUrl"] = this.logoutUrl;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IAdConfigDto {
    /** Is AD Enabled for this Tenant? */
    isAdEnabled?: boolean;
    /** URL for 3rd party discovery document */
    issuerUrl?: string;
    /** URL for 3rd party logout endpoint */
    logoutUrl?: string;
    /** 3rd party provided client id */
    clientId?: string;

    [key: string]: any;
}

/** User information from Teller REST API */
export class TellerUserInfoDto implements ITellerUserInfoDto {
    /** The user's login identifier */
    logonId?: string;
    /** The user's full name */
    fullName?: string;
    /** Whether the user is a super user with all permissions */
    isSuperUser?: boolean;
    /** List of systems the user has access to */
    systems?: TellerSystemInfoDto[];

    [key: string]: any;

    constructor(data?: ITellerUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logonId = _data["logonId"];
            this.fullName = _data["fullName"];
            this.isSuperUser = _data["isSuperUser"];
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(TellerSystemInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logonId"] = this.logonId;
        data["fullName"] = this.fullName;
        data["isSuperUser"] = this.isSuperUser;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        return data;
    }
}

/** User information from Teller REST API */
export interface ITellerUserInfoDto {
    /** The user's login identifier */
    logonId?: string;
    /** The user's full name */
    fullName?: string;
    /** Whether the user is a super user with all permissions */
    isSuperUser?: boolean;
    /** List of systems the user has access to */
    systems?: TellerSystemInfoDto[];

    [key: string]: any;
}

/** System information from Teller REST API */
export class TellerSystemInfoDto implements ITellerSystemInfoDto {
    /** The system ID */
    systemId?: number;
    /** The system description */
    description?: string;
    /** The system number */
    systemNo?: number;
    /** List of locations in the system */
    locations?: TellerLocationInfoDto[];
    /** List of payment channels in the system */
    paymentChannels?: TellerPaymentChannelInfoDto[];
    /** List of privileges the user has in this system */
    privileges?: string[];
    /** The tender types Teller reports for this system. Present so a connection being created can offer the same picker a saved one does - Teller reports these per system, and the system is chosen in the dialog. Empty when this Teller does not supply them (pre-7.17), which is the signal to type the name instead. */
    tenderTypes?: TellerTenderTypeDto[];

    [key: string]: any;

    constructor(data?: ITellerSystemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.systemId = _data["systemId"];
            this.description = _data["description"];
            this.systemNo = _data["systemNo"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TellerLocationInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["paymentChannels"])) {
                this.paymentChannels = [] as any;
                for (let item of _data["paymentChannels"])
                    this.paymentChannels!.push(TellerPaymentChannelInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["privileges"])) {
                this.privileges = [] as any;
                for (let item of _data["privileges"])
                    this.privileges!.push(item);
            }
            if (Array.isArray(_data["tenderTypes"])) {
                this.tenderTypes = [] as any;
                for (let item of _data["tenderTypes"])
                    this.tenderTypes!.push(TellerTenderTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerSystemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerSystemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["systemId"] = this.systemId;
        data["description"] = this.description;
        data["systemNo"] = this.systemNo;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentChannels)) {
            data["paymentChannels"] = [];
            for (let item of this.paymentChannels)
                data["paymentChannels"].push(item.toJSON());
        }
        if (Array.isArray(this.privileges)) {
            data["privileges"] = [];
            for (let item of this.privileges)
                data["privileges"].push(item);
        }
        if (Array.isArray(this.tenderTypes)) {
            data["tenderTypes"] = [];
            for (let item of this.tenderTypes)
                data["tenderTypes"].push(item.toJSON());
        }
        return data;
    }
}

/** System information from Teller REST API */
export interface ITellerSystemInfoDto {
    /** The system ID */
    systemId?: number;
    /** The system description */
    description?: string;
    /** The system number */
    systemNo?: number;
    /** List of locations in the system */
    locations?: TellerLocationInfoDto[];
    /** List of payment channels in the system */
    paymentChannels?: TellerPaymentChannelInfoDto[];
    /** List of privileges the user has in this system */
    privileges?: string[];
    /** The tender types Teller reports for this system. Present so a connection being created can offer the same picker a saved one does - Teller reports these per system, and the system is chosen in the dialog. Empty when this Teller does not supply them (pre-7.17), which is the signal to type the name instead. */
    tenderTypes?: TellerTenderTypeDto[];

    [key: string]: any;
}

/** Location information from Teller REST API */
export class TellerLocationInfoDto implements ITellerLocationInfoDto {
    /** The location ID */
    locationId?: number;
    /** The location number */
    locationNo?: number;
    /** The location name */
    name?: string;
    /** Whether this is the default location */
    isDefault?: boolean;

    [key: string]: any;

    constructor(data?: ITellerLocationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.locationId = _data["locationId"];
            this.locationNo = _data["locationNo"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): TellerLocationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerLocationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["locationId"] = this.locationId;
        data["locationNo"] = this.locationNo;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

/** Location information from Teller REST API */
export interface ITellerLocationInfoDto {
    /** The location ID */
    locationId?: number;
    /** The location number */
    locationNo?: number;
    /** The location name */
    name?: string;
    /** Whether this is the default location */
    isDefault?: boolean;

    [key: string]: any;
}

/** Payment channel information from Teller REST API */
export class TellerPaymentChannelInfoDto implements ITellerPaymentChannelInfoDto {
    /** The payment channel number */
    paymentChannelNo?: number;
    /** The payment channel name */
    name?: string;

    [key: string]: any;

    constructor(data?: ITellerPaymentChannelInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentChannelNo = _data["paymentChannelNo"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TellerPaymentChannelInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerPaymentChannelInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentChannelNo"] = this.paymentChannelNo;
        data["name"] = this.name;
        return data;
    }
}

/** Payment channel information from Teller REST API */
export interface ITellerPaymentChannelInfoDto {
    /** The payment channel number */
    paymentChannelNo?: number;
    /** The payment channel name */
    name?: string;

    [key: string]: any;
}

/** Plugin information from Teller REST API */
export class TellerPluginInfoDto implements ITellerPluginInfoDto {
    /** The plugin number */
    pluginNo?: number;
    /** The plugin description */
    description?: string;

    [key: string]: any;

    constructor(data?: ITellerPluginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pluginNo = _data["pluginNo"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TellerPluginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerPluginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pluginNo"] = this.pluginNo;
        data["description"] = this.description;
        return data;
    }
}

/** Plugin information from Teller REST API */
export interface ITellerPluginInfoDto {
    /** The plugin number */
    pluginNo?: number;
    /** The plugin description */
    description?: string;

    [key: string]: any;
}

/** Teller Online plugins grouped by system */
export class TellerPluginsDto implements ITellerPluginsDto {
    /** List of systems with their plugins */
    systems?: TellerPluginSystemDto[];

    [key: string]: any;

    constructor(data?: ITellerPluginsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(TellerPluginSystemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerPluginsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerPluginsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        return data;
    }
}

/** Teller Online plugins grouped by system */
export interface ITellerPluginsDto {
    /** List of systems with their plugins */
    systems?: TellerPluginSystemDto[];

    [key: string]: any;
}

/** System with plugins from Teller REST API */
export class TellerPluginSystemDto implements ITellerPluginSystemDto {
    /** The system ID */
    systemId?: number;
    /** The system description */
    description?: string;
    /** The system number */
    systemNo?: number;
    /** List of plugins available in the system */
    plugins?: TellerPluginInfoDto[];

    [key: string]: any;

    constructor(data?: ITellerPluginSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.systemId = _data["systemId"];
            this.description = _data["description"];
            this.systemNo = _data["systemNo"];
            if (Array.isArray(_data["plugins"])) {
                this.plugins = [] as any;
                for (let item of _data["plugins"])
                    this.plugins!.push(TellerPluginInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerPluginSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerPluginSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["systemId"] = this.systemId;
        data["description"] = this.description;
        data["systemNo"] = this.systemNo;
        if (Array.isArray(this.plugins)) {
            data["plugins"] = [];
            for (let item of this.plugins)
                data["plugins"].push(item.toJSON());
        }
        return data;
    }
}

/** System with plugins from Teller REST API */
export interface ITellerPluginSystemDto {
    /** The system ID */
    systemId?: number;
    /** The system description */
    description?: string;
    /** The system number */
    systemNo?: number;
    /** List of plugins available in the system */
    plugins?: TellerPluginInfoDto[];

    [key: string]: any;
}

/** Container for Teller item types grouped by system */
export class TellerItemTypesDto implements ITellerItemTypesDto {
    /** List of systems with their item types */
    systems?: TellerItemTypeSystemDto[];

    [key: string]: any;

    constructor(data?: ITellerItemTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(TellerItemTypeSystemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerItemTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerItemTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        return data;
    }
}

/** Container for Teller item types grouped by system */
export interface ITellerItemTypesDto {
    /** List of systems with their item types */
    systems?: TellerItemTypeSystemDto[];

    [key: string]: any;
}

/** System with its item types from Teller REST API */
export class TellerItemTypeSystemDto implements ITellerItemTypeSystemDto {
    /** The system ID */
    systemId?: number;
    /** The system description (matches TellerSystemCode in database) */
    description?: string;
    /** The system number */
    systemNo?: number;
    /** List of item types available in the system */
    itemTypes?: TellerItemTypeInfoDto[];

    [key: string]: any;

    constructor(data?: ITellerItemTypeSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.systemId = _data["systemId"];
            this.description = _data["description"];
            this.systemNo = _data["systemNo"];
            if (Array.isArray(_data["itemTypes"])) {
                this.itemTypes = [] as any;
                for (let item of _data["itemTypes"])
                    this.itemTypes!.push(TellerItemTypeInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerItemTypeSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerItemTypeSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["systemId"] = this.systemId;
        data["description"] = this.description;
        data["systemNo"] = this.systemNo;
        if (Array.isArray(this.itemTypes)) {
            data["itemTypes"] = [];
            for (let item of this.itemTypes)
                data["itemTypes"].push(item.toJSON());
        }
        return data;
    }
}

/** System with its item types from Teller REST API */
export interface ITellerItemTypeSystemDto {
    /** The system ID */
    systemId?: number;
    /** The system description (matches TellerSystemCode in database) */
    description?: string;
    /** The system number */
    systemNo?: number;
    /** List of item types available in the system */
    itemTypes?: TellerItemTypeInfoDto[];

    [key: string]: any;
}

/** Item type information from Teller REST API */
export class TellerItemTypeInfoDto implements ITellerItemTypeInfoDto {
    /** The item type ID */
    itemTypeId?: number;
    /** The item type configuration number */
    itemTypeNo?: number;
    /** The item type description */
    description?: string;

    [key: string]: any;

    constructor(data?: ITellerItemTypeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.itemTypeId = _data["itemTypeId"];
            this.itemTypeNo = _data["itemTypeNo"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TellerItemTypeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerItemTypeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["itemTypeId"] = this.itemTypeId;
        data["itemTypeNo"] = this.itemTypeNo;
        data["description"] = this.description;
        return data;
    }
}

/** Item type information from Teller REST API */
export interface ITellerItemTypeInfoDto {
    /** The item type ID */
    itemTypeId?: number;
    /** The item type configuration number */
    itemTypeNo?: number;
    /** The item type description */
    description?: string;

    [key: string]: any;
}

export class SearchTypeDto implements ISearchTypeDto {
    id?: number;
    configNo?: number;
    /** Unique Teller fetch type name */
    tellerFetchTypeName?: string;
    /** Label to display for the search type */
    label?: string;
    /** Title of instructional text for the search type */
    instructionsTitle?: string;
    /** Detailed instructions for the search */
    instructionsText?: string;
    /** Image to display (maybe a sample bill) */
    instructionsImage?: string;
    instructionsImageAltText?: string;
    active?: boolean;
    pageId?: number;
    template?: string;
    isLookaheadSearch?: boolean;
    lookaheadField?: string;
    flow?: number;
    loadMoreIncrement?: number;

    [key: string]: any;

    constructor(data?: ISearchTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.configNo = _data["configNo"];
            this.tellerFetchTypeName = _data["tellerFetchTypeName"];
            this.label = _data["label"];
            this.instructionsTitle = _data["instructionsTitle"];
            this.instructionsText = _data["instructionsText"];
            this.instructionsImage = _data["instructionsImage"];
            this.instructionsImageAltText = _data["instructionsImageAltText"];
            this.active = _data["active"];
            this.pageId = _data["pageId"];
            this.template = _data["template"];
            this.isLookaheadSearch = _data["isLookaheadSearch"];
            this.lookaheadField = _data["lookaheadField"];
            this.flow = _data["flow"];
            this.loadMoreIncrement = _data["loadMoreIncrement"];
        }
    }

    static fromJS(data: any): SearchTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["configNo"] = this.configNo;
        data["tellerFetchTypeName"] = this.tellerFetchTypeName;
        data["label"] = this.label;
        data["instructionsTitle"] = this.instructionsTitle;
        data["instructionsText"] = this.instructionsText;
        data["instructionsImage"] = this.instructionsImage;
        data["instructionsImageAltText"] = this.instructionsImageAltText;
        data["active"] = this.active;
        data["pageId"] = this.pageId;
        data["template"] = this.template;
        data["isLookaheadSearch"] = this.isLookaheadSearch;
        data["lookaheadField"] = this.lookaheadField;
        data["flow"] = this.flow;
        data["loadMoreIncrement"] = this.loadMoreIncrement;
        return data;
    }
}

export interface ISearchTypeDto {
    id?: number;
    configNo?: number;
    /** Unique Teller fetch type name */
    tellerFetchTypeName?: string;
    /** Label to display for the search type */
    label?: string;
    /** Title of instructional text for the search type */
    instructionsTitle?: string;
    /** Detailed instructions for the search */
    instructionsText?: string;
    /** Image to display (maybe a sample bill) */
    instructionsImage?: string;
    instructionsImageAltText?: string;
    active?: boolean;
    pageId?: number;
    template?: string;
    isLookaheadSearch?: boolean;
    lookaheadField?: string;
    flow?: number;
    loadMoreIncrement?: number;

    [key: string]: any;
}

/** A cart in the admin portal */
export class CartDto implements ICartDto {
    /** Unique ID of the user from the TOP DB */
    onlineUserId?: number;
    /** The status of the cart */
    status!: CartStatusEnumDto;
    /** The date/time that this cart was last updated */
    lastChangeDate?: Date;
    /** Unique ID of cart */
    cartId?: number;
    /** Unique GUID of cart */
    cartGuid?: string;
    /** Receipt number if the cart was purchased */
    receiptNumber?: string;
    /** The email address of the guest user */
    emailAddress?: string;
    /** Number of items in the cart */
    numberOfItems?: number;
    /** Total amount of items in the cart */
    totalAmount?: number;

    [key: string]: any;

    constructor(data?: ICartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.onlineUserId = _data["onlineUserId"];
            this.status = _data["status"];
            this.lastChangeDate = _data["lastChangeDate"] ? new Date(_data["lastChangeDate"].toString()) : <any>undefined;
            this.cartId = _data["cartId"];
            this.cartGuid = _data["cartGuid"];
            this.receiptNumber = _data["receiptNumber"];
            this.emailAddress = _data["emailAddress"];
            this.numberOfItems = _data["numberOfItems"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): CartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["onlineUserId"] = this.onlineUserId;
        data["status"] = this.status;
        data["lastChangeDate"] = this.lastChangeDate ? this.lastChangeDate.toISOString() : <any>undefined;
        data["cartId"] = this.cartId;
        data["cartGuid"] = this.cartGuid;
        data["receiptNumber"] = this.receiptNumber;
        data["emailAddress"] = this.emailAddress;
        data["numberOfItems"] = this.numberOfItems;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

/** A cart in the admin portal */
export interface ICartDto {
    /** Unique ID of the user from the TOP DB */
    onlineUserId?: number;
    /** The status of the cart */
    status: CartStatusEnumDto;
    /** The date/time that this cart was last updated */
    lastChangeDate?: Date;
    /** Unique ID of cart */
    cartId?: number;
    /** Unique GUID of cart */
    cartGuid?: string;
    /** Receipt number if the cart was purchased */
    receiptNumber?: string;
    /** The email address of the guest user */
    emailAddress?: string;
    /** Number of items in the cart */
    numberOfItems?: number;
    /** Total amount of items in the cart */
    totalAmount?: number;

    [key: string]: any;
}

/** The items that user has added to the dashboard */
export class DashboardItemDto implements IDashboardItemDto {
    /** The items in the cart */
    items?: ItemDto[];

    [key: string]: any;

    constructor(data?: IDashboardItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

/** The items that user has added to the dashboard */
export interface IDashboardItemDto {
    /** The items in the cart */
    items?: ItemDto[];

    [key: string]: any;
}

/** A payable item (fee, tax charge, etc) */
export class ItemDto implements IItemDto {
    /** Unique GUID */
    itemGuid!: string;
    /** Identifies this item to the business system */
    externalFileNo?: string;
    /** Item Type No if this represents a Teller misc item */
    tellerItemTypeNo?: number;
    /** The line item description if this represents a Teller misc item */
    tellerItemDescription?: string;
    /** Business-related title to display for this item */
    title!: string;
    /** Summary to display (Markdown) */
    summary?: string;
    /** Bill summary for more details (Markdown) */
    billSummary?: string;
    /** The balance due for this item */
    balance?: number;
    /** URL to PDF representing the item (for bills) */
    billUrl?: string;
    amountInCart?: number;
    /** Unique ID of Cart */
    cartId?: number;
    /** search type id used by user to search this item */
    searchTypeId?: number;
    /** search value used by user to search this item */
    searchValue?: string;
    /** Payment options for this item */
    paymentOptions?: ItemPaymentOptionDto[];
    /** URL to PDF supporting this given item */
    supportingDocUrl?: string;
    selectedPaymentOption?: ItemPaymentOptionDto;

    [key: string]: any;

    constructor(data?: IItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.itemGuid = _data["itemGuid"];
            this.externalFileNo = _data["externalFileNo"];
            this.tellerItemTypeNo = _data["tellerItemTypeNo"];
            this.tellerItemDescription = _data["tellerItemDescription"];
            this.title = _data["title"];
            this.summary = _data["summary"];
            this.billSummary = _data["billSummary"];
            this.balance = _data["balance"];
            this.billUrl = _data["billUrl"];
            this.amountInCart = _data["amountInCart"];
            this.cartId = _data["cartId"];
            this.searchTypeId = _data["searchTypeId"];
            this.searchValue = _data["searchValue"];
            if (Array.isArray(_data["paymentOptions"])) {
                this.paymentOptions = [] as any;
                for (let item of _data["paymentOptions"])
                    this.paymentOptions!.push(ItemPaymentOptionDto.fromJS(item));
            }
            this.supportingDocUrl = _data["supportingDocUrl"];
            this.selectedPaymentOption = _data["selectedPaymentOption"] ? ItemPaymentOptionDto.fromJS(_data["selectedPaymentOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["itemGuid"] = this.itemGuid;
        data["externalFileNo"] = this.externalFileNo;
        data["tellerItemTypeNo"] = this.tellerItemTypeNo;
        data["tellerItemDescription"] = this.tellerItemDescription;
        data["title"] = this.title;
        data["summary"] = this.summary;
        data["billSummary"] = this.billSummary;
        data["balance"] = this.balance;
        data["billUrl"] = this.billUrl;
        data["amountInCart"] = this.amountInCart;
        data["cartId"] = this.cartId;
        data["searchTypeId"] = this.searchTypeId;
        data["searchValue"] = this.searchValue;
        if (Array.isArray(this.paymentOptions)) {
            data["paymentOptions"] = [];
            for (let item of this.paymentOptions)
                data["paymentOptions"].push(item.toJSON());
        }
        data["supportingDocUrl"] = this.supportingDocUrl;
        data["selectedPaymentOption"] = this.selectedPaymentOption ? this.selectedPaymentOption.toJSON() : <any>undefined;
        return data;
    }
}

/** A payable item (fee, tax charge, etc) */
export interface IItemDto {
    /** Unique GUID */
    itemGuid: string;
    /** Identifies this item to the business system */
    externalFileNo?: string;
    /** Item Type No if this represents a Teller misc item */
    tellerItemTypeNo?: number;
    /** The line item description if this represents a Teller misc item */
    tellerItemDescription?: string;
    /** Business-related title to display for this item */
    title: string;
    /** Summary to display (Markdown) */
    summary?: string;
    /** Bill summary for more details (Markdown) */
    billSummary?: string;
    /** The balance due for this item */
    balance?: number;
    /** URL to PDF representing the item (for bills) */
    billUrl?: string;
    amountInCart?: number;
    /** Unique ID of Cart */
    cartId?: number;
    /** search type id used by user to search this item */
    searchTypeId?: number;
    /** search value used by user to search this item */
    searchValue?: string;
    /** Payment options for this item */
    paymentOptions?: ItemPaymentOptionDto[];
    /** URL to PDF supporting this given item */
    supportingDocUrl?: string;
    selectedPaymentOption?: ItemPaymentOptionDto;

    [key: string]: any;
}

/** A payment option for an item */
export class ItemPaymentOptionDto implements IItemPaymentOptionDto {
    /** Unique name for this payment option */
    name!: string;
    /** Label to display */
    label!: string;
    /** Indicates if this payment option represents a custom amount (will require user entry) */
    isCustomAmount!: boolean;
    /** The amount to pay */
    amount?: number;

    [key: string]: any;

    constructor(data?: IItemPaymentOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.label = _data["label"];
            this.isCustomAmount = _data["isCustomAmount"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ItemPaymentOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPaymentOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["label"] = this.label;
        data["isCustomAmount"] = this.isCustomAmount;
        data["amount"] = this.amount;
        return data;
    }
}

/** A payment option for an item */
export interface IItemPaymentOptionDto {
    /** Unique name for this payment option */
    name: string;
    /** Label to display */
    label: string;
    /** Indicates if this payment option represents a custom amount (will require user entry) */
    isCustomAmount: boolean;
    /** The amount to pay */
    amount?: number;

    [key: string]: any;
}

/** List of payments done by user */
export class UserPaymentsDto implements IUserPaymentsDto {
    /** the status of the cart */
    status?: string;
    /** Unique identifier for the payment. */
    paymentIdentifier?: string;
    /** Date cart was finalized */
    finalizedDate?: Date;
    /** Teller Receipt No of the posted payment */
    tellerReceiptNo?: string;
    /** Amount paid */
    amount?: number;
    /** Payment method */
    paymentMethod?: string;

    [key: string]: any;

    constructor(data?: IUserPaymentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.finalizedDate = _data["finalizedDate"] ? new Date(_data["finalizedDate"].toString()) : <any>undefined;
            this.tellerReceiptNo = _data["tellerReceiptNo"];
            this.amount = _data["amount"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): UserPaymentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaymentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["finalizedDate"] = this.finalizedDate ? this.finalizedDate.toISOString() : <any>undefined;
        data["tellerReceiptNo"] = this.tellerReceiptNo;
        data["amount"] = this.amount;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

/** List of payments done by user */
export interface IUserPaymentsDto {
    /** the status of the cart */
    status?: string;
    /** Unique identifier for the payment. */
    paymentIdentifier?: string;
    /** Date cart was finalized */
    finalizedDate?: Date;
    /** Teller Receipt No of the posted payment */
    tellerReceiptNo?: string;
    /** Amount paid */
    amount?: number;
    /** Payment method */
    paymentMethod?: string;

    [key: string]: any;
}

export class AddCartEventRequestDto implements IAddCartEventRequestDto {
    /** Cart event message */
    message!: string;

    [key: string]: any;

    constructor(data?: IAddCartEventRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AddCartEventRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddCartEventRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IAddCartEventRequestDto {
    /** Cart event message */
    message: string;

    [key: string]: any;
}

export class ProcessECheckRequestDto implements IProcessECheckRequestDto {
    /** Type of account */
    accountType!: ProcessECheckRequestDtoAccountType;
    /** E-Check Account Number */
    accountNumber!: string;
    /** E-Check Routing Number */
    routingNumber!: string;

    [key: string]: any;

    constructor(data?: IProcessECheckRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.accountType = _data["accountType"];
            this.accountNumber = _data["accountNumber"];
            this.routingNumber = _data["routingNumber"];
        }
    }

    static fromJS(data: any): ProcessECheckRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessECheckRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["accountType"] = this.accountType;
        data["accountNumber"] = this.accountNumber;
        data["routingNumber"] = this.routingNumber;
        return data;
    }
}

export interface IProcessECheckRequestDto {
    /** Type of account */
    accountType: ProcessECheckRequestDtoAccountType;
    /** E-Check Account Number */
    accountNumber: string;
    /** E-Check Routing Number */
    routingNumber: string;

    [key: string]: any;
}

/** Payment details of a cart in the admin portal */
export class CartPaymentDetailsDto implements ICartPaymentDetailsDto {
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    /** Payment method and reference */
    paymentMethod?: UserPaymentMethodDto;
    /** The items in the cart */
    items?: CartItemDto[];
    /** Payment method and reference */
    convenienceFee?: any;
    total?: number;
    subtotal?: number;
    status?: string;

    [key: string]: any;

    constructor(data?: ICartPaymentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerReceiptNumber = _data["tellerReceiptNumber"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"] ? UserPaymentMethodDto.fromJS(_data["paymentMethod"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CartItemDto.fromJS(item));
            }
            this.convenienceFee = _data["convenienceFee"];
            this.total = _data["total"];
            this.subtotal = _data["subtotal"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CartPaymentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartPaymentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerReceiptNumber"] = this.tellerReceiptNumber;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["convenienceFee"] = this.convenienceFee;
        data["total"] = this.total;
        data["subtotal"] = this.subtotal;
        data["status"] = this.status;
        return data;
    }
}

/** Payment details of a cart in the admin portal */
export interface ICartPaymentDetailsDto {
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    /** Payment method and reference */
    paymentMethod?: UserPaymentMethodDto;
    /** The items in the cart */
    items?: CartItemDto[];
    /** Payment method and reference */
    convenienceFee?: any;
    total?: number;
    subtotal?: number;
    status?: string;

    [key: string]: any;
}

/** Type of payment method used */
export enum PaymentTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
}

export class CartItemDto implements ICartItemDto {
    /** The cart type */
    type?: number;
    /** The cart name */
    name?: string;
    /** The cart title */
    title?: string;
    /** The cart amount */
    amount?: number;
    /** The cart amount */
    fee?: number;

    [key: string]: any;

    constructor(data?: ICartItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.amount = _data["amount"];
            this.fee = _data["fee"];
        }
    }

    static fromJS(data: any): CartItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["name"] = this.name;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["fee"] = this.fee;
        return data;
    }
}

export interface ICartItemDto {
    /** The cart type */
    type?: number;
    /** The cart name */
    name?: string;
    /** The cart title */
    title?: string;
    /** The cart amount */
    amount?: number;
    /** The cart amount */
    fee?: number;

    [key: string]: any;
}

/** Activity event for a payment */
export class ActivityLogDto implements IActivityLogDto {
    /** Unique event id */
    eventId?: number;
    /** The event DateTime */
    dateTime?: Date;
    /** The event message */
    message?: string;
    /** The payment's status at the time of the event */
    status?: PaymentStatusEnumDto;
    /** The error details of the event */
    errorDetails?: string;
    /** The technical details of the event */
    technicalDetails?: string;
    /** Additional details regarding cart activity */
    additionalDetails?: string;

    [key: string]: any;

    constructor(data?: IActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.eventId = _data["eventId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.status = _data["status"];
            this.errorDetails = _data["errorDetails"];
            this.technicalDetails = _data["technicalDetails"];
            this.additionalDetails = _data["additionalDetails"];
        }
    }

    static fromJS(data: any): ActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["eventId"] = this.eventId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["status"] = this.status;
        data["errorDetails"] = this.errorDetails;
        data["technicalDetails"] = this.technicalDetails;
        data["additionalDetails"] = this.additionalDetails;
        return data;
    }
}

/** Activity event for a payment */
export interface IActivityLogDto {
    /** Unique event id */
    eventId?: number;
    /** The event DateTime */
    dateTime?: Date;
    /** The event message */
    message?: string;
    /** The payment's status at the time of the event */
    status?: PaymentStatusEnumDto;
    /** The error details of the event */
    errorDetails?: string;
    /** The technical details of the event */
    technicalDetails?: string;
    /** Additional details regarding cart activity */
    additionalDetails?: string;

    [key: string]: any;
}

/** Cart custom value */
export class CustomValueDto implements ICustomValueDto {
    /** Name of custom value */
    name?: string;
    /** Value of custom value */
    value?: string;

    [key: string]: any;

    constructor(data?: ICustomValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

/** Cart custom value */
export interface ICustomValueDto {
    /** Name of custom value */
    name?: string;
    /** Value of custom value */
    value?: string;

    [key: string]: any;
}

/** Type of a payment. */
export class UserPaymentMethodDto implements IUserPaymentMethodDto {
    /** The payment type */
    type!: PaymentTypeEnumDto;
    /** The payment reference */
    reference?: string;

    [key: string]: any;

    constructor(data?: IUserPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): UserPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["reference"] = this.reference;
        return data;
    }
}

/** Type of a payment. */
export interface IUserPaymentMethodDto {
    /** The payment type */
    type: PaymentTypeEnumDto;
    /** The payment reference */
    reference?: string;

    [key: string]: any;
}

export class UserActivityHistoryDto implements IUserActivityHistoryDto {
    /** The info that was changed (e.g. name, email or password) */
    infoChanged?: string;
    /** Date and time of changes */
    changedAt?: string;
    /** Device type that was used to make changes (e.g. Laptop Windows, iOS, Mac) */
    deviceType?: string;
    /** The location the changes were made from, based on IP (e.g. Denver, CO) */
    location?: string;
    /** Who made a change (admin or user) */
    changedBy?: string;

    [key: string]: any;

    constructor(data?: IUserActivityHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.infoChanged = _data["infoChanged"];
            this.changedAt = _data["changedAt"];
            this.deviceType = _data["deviceType"];
            this.location = _data["location"];
            this.changedBy = _data["changedBy"];
        }
    }

    static fromJS(data: any): UserActivityHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["infoChanged"] = this.infoChanged;
        data["changedAt"] = this.changedAt;
        data["deviceType"] = this.deviceType;
        data["location"] = this.location;
        data["changedBy"] = this.changedBy;
        return data;
    }
}

export interface IUserActivityHistoryDto {
    /** The info that was changed (e.g. name, email or password) */
    infoChanged?: string;
    /** Date and time of changes */
    changedAt?: string;
    /** Device type that was used to make changes (e.g. Laptop Windows, iOS, Mac) */
    deviceType?: string;
    /** The location the changes were made from, based on IP (e.g. Denver, CO) */
    location?: string;
    /** Who made a change (admin or user) */
    changedBy?: string;

    [key: string]: any;
}

/** Status of a cart. */
export enum ReceiverTypeEnumDto {
    Email = "Email",
    SMS = "SMS",
}

export class UserNotificationHistoryDto implements IUserNotificationHistoryDto {
    /** Date/time notification was sent */
    sendDate?: Date;
    /** Receiver (email or phone number) */
    receiverType?: ReceiverTypeEnumDto;
    /** Body of the message */
    body?: string;
    /** Subject of the message */
    subject?: string;
    /** Receiving number/email of the message */
    sentTo?: string;

    [key: string]: any;

    constructor(data?: IUserNotificationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.receiverType = _data["receiverType"];
            this.body = _data["body"];
            this.subject = _data["subject"];
            this.sentTo = _data["sentTo"];
        }
    }

    static fromJS(data: any): UserNotificationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["receiverType"] = this.receiverType;
        data["body"] = this.body;
        data["subject"] = this.subject;
        data["sentTo"] = this.sentTo;
        return data;
    }
}

export interface IUserNotificationHistoryDto {
    /** Date/time notification was sent */
    sendDate?: Date;
    /** Receiver (email or phone number) */
    receiverType?: ReceiverTypeEnumDto;
    /** Body of the message */
    body?: string;
    /** Subject of the message */
    subject?: string;
    /** Receiving number/email of the message */
    sentTo?: string;

    [key: string]: any;
}

export class UserDto implements IUserDto {
    /** Id of user */
    id?: string;
    /** OnlineId of user */
    onlineUserId?: number | undefined;
    /** Full name of user */
    fullName?: string;
    /** Phone number of user */
    phoneNumber?: string;
    /** Email of user */
    email?: string;

    [key: string]: any;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.onlineUserId = _data["onlineUserId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["onlineUserId"] = this.onlineUserId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserDto {
    /** Id of user */
    id?: string;
    /** OnlineId of user */
    onlineUserId?: number | undefined;
    /** Full name of user */
    fullName?: string;
    /** Phone number of user */
    phoneNumber?: string;
    /** Email of user */
    email?: string;

    [key: string]: any;
}

/** Details of the currently logged in user */
export class CurrentUserDto implements ICurrentUserDto {
    /** Name of the user */
    name?: string;
    /** role of the user (e.g. admin, etc) */
    role?: string;
    /** Whether or not the user is signed in */
    isSignedIn?: boolean;

    [key: string]: any;

    constructor(data?: ICurrentUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.role = _data["role"];
            this.isSignedIn = _data["isSignedIn"];
        }
    }

    static fromJS(data: any): CurrentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["role"] = this.role;
        data["isSignedIn"] = this.isSignedIn;
        return data;
    }
}

/** Details of the currently logged in user */
export interface ICurrentUserDto {
    /** Name of the user */
    name?: string;
    /** role of the user (e.g. admin, etc) */
    role?: string;
    /** Whether or not the user is signed in */
    isSignedIn?: boolean;

    [key: string]: any;
}

/** Administrator details for a payment such as if syncing is allowed */
export class PaymentAdminDetailsDto implements IPaymentAdminDetailsDto {
    /** Indicates if this payment can be synced with Teller */
    isSyncAllowed?: boolean;
    /** Indicates if this payment can be cancelled */
    isCancelAllowed?: boolean;
    /** Indicates if this payment can be retried */
    isRetryAllowed?: boolean;
    /** Indicates if this payment can be marked as refunded */
    isRefundAllowed?: boolean;
    /** The PSP-side transaction id for this payment, resolved by the
backend from the right plugin-driven custom value (avoids the
frontend needing per-PSP ngIf logic). Null when no tracking
value is present.
 */
    transactionId?: string | undefined;
    /** The payment integration that processed this payment.
 */
    paymentIntegration?: PaymentIntegrationEnumDto;
    /** User-facing label rendered next to <c>transactionId</c> on the
admin UI. Resolved server-side per integration: most managers
return a hard-coded per-PSP string ("Datacap Reference Number",
"Nic Token", …); Generic composes <c>{pluginDisplayName} Transaction ID</c>
from the resolved (system, plugin) pair, falling back to "Transaction ID".
Null when <c>transactionId</c> is null.
 */
    transactionIdLabel?: string | undefined;

    [key: string]: any;

    constructor(data?: IPaymentAdminDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSyncAllowed = _data["isSyncAllowed"];
            this.isCancelAllowed = _data["isCancelAllowed"];
            this.isRetryAllowed = _data["isRetryAllowed"];
            this.isRefundAllowed = _data["isRefundAllowed"];
            this.transactionId = _data["transactionId"];
            this.paymentIntegration = _data["paymentIntegration"];
            this.transactionIdLabel = _data["transactionIdLabel"];
        }
    }

    static fromJS(data: any): PaymentAdminDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAdminDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSyncAllowed"] = this.isSyncAllowed;
        data["isCancelAllowed"] = this.isCancelAllowed;
        data["isRetryAllowed"] = this.isRetryAllowed;
        data["isRefundAllowed"] = this.isRefundAllowed;
        data["transactionId"] = this.transactionId;
        data["paymentIntegration"] = this.paymentIntegration;
        data["transactionIdLabel"] = this.transactionIdLabel;
        return data;
    }
}

/** Administrator details for a payment such as if syncing is allowed */
export interface IPaymentAdminDetailsDto {
    /** Indicates if this payment can be synced with Teller */
    isSyncAllowed?: boolean;
    /** Indicates if this payment can be cancelled */
    isCancelAllowed?: boolean;
    /** Indicates if this payment can be retried */
    isRetryAllowed?: boolean;
    /** Indicates if this payment can be marked as refunded */
    isRefundAllowed?: boolean;
    /** The PSP-side transaction id for this payment, resolved by the
backend from the right plugin-driven custom value (avoids the
frontend needing per-PSP ngIf logic). Null when no tracking
value is present.
 */
    transactionId?: string | undefined;
    /** The payment integration that processed this payment.
 */
    paymentIntegration?: PaymentIntegrationEnumDto;
    /** User-facing label rendered next to <c>transactionId</c> on the
admin UI. Resolved server-side per integration: most managers
return a hard-coded per-PSP string ("Datacap Reference Number",
"Nic Token", …); Generic composes <c>{pluginDisplayName} Transaction ID</c>
from the resolved (system, plugin) pair, falling back to "Transaction ID".
Null when <c>transactionId</c> is null.
 */
    transactionIdLabel?: string | undefined;

    [key: string]: any;
}

/** The cart guid of the next payment and previous payment */
export class PaymentsNextPrevDto implements IPaymentsNextPrevDto {
    next?: string;
    prev?: string;

    [key: string]: any;

    constructor(data?: IPaymentsNextPrevDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.next = _data["next"];
            this.prev = _data["prev"];
        }
    }

    static fromJS(data: any): PaymentsNextPrevDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsNextPrevDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["next"] = this.next;
        data["prev"] = this.prev;
        return data;
    }
}

/** The cart guid of the next payment and previous payment */
export interface IPaymentsNextPrevDto {
    next?: string;
    prev?: string;

    [key: string]: any;
}

/** Information regarding an admin user-initiated request to mark a payment as refunded */
export class RefundPaymentRequestDto implements IRefundPaymentRequestDto {
    comments?: string;

    [key: string]: any;

    constructor(data?: IRefundPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): RefundPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefundPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["comments"] = this.comments;
        return data;
    }
}

/** Information regarding an admin user-initiated request to mark a payment as refunded */
export interface IRefundPaymentRequestDto {
    comments?: string;

    [key: string]: any;
}

/** Request body for canceling a scheduled payment */
export class CancelScheduledPaymentRequestDto implements ICancelScheduledPaymentRequestDto {
    /** Free-form reason for the cancellation */
    cancellationReason?: string | undefined;

    [key: string]: any;

    constructor(data?: ICancelScheduledPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): CancelScheduledPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelScheduledPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }
}

/** Request body for canceling a scheduled payment */
export interface ICancelScheduledPaymentRequestDto {
    /** Free-form reason for the cancellation */
    cancellationReason?: string | undefined;

    [key: string]: any;
}

/** Information regarding an admin user-initiated request to cancel a payment */
export class CancelPaymentRequestDto implements ICancelPaymentRequestDto {
    comments?: string;

    [key: string]: any;

    constructor(data?: ICancelPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CancelPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["comments"] = this.comments;
        return data;
    }
}

/** Information regarding an admin user-initiated request to cancel a payment */
export interface ICancelPaymentRequestDto {
    comments?: string;

    [key: string]: any;
}

/** Information regarding an admin user-initiated request to retry a payment */
export class RetryPaymentRequestDto implements IRetryPaymentRequestDto {
    comments?: string;

    [key: string]: any;

    constructor(data?: IRetryPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): RetryPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetryPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["comments"] = this.comments;
        return data;
    }
}

/** Information regarding an admin user-initiated request to retry a payment */
export interface IRetryPaymentRequestDto {
    comments?: string;

    [key: string]: any;
}

/** A few simple details that describe the user's history */
export class BasicUserHistoryDto implements IBasicUserHistoryDto {
    /** The date/time that this user was initially created */
    creationDate?: Date;
    /** The date/time that this user last made a payment */
    lastPaymentDate?: Date;

    [key: string]: any;

    constructor(data?: IBasicUserHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BasicUserHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicUserHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        return data;
    }
}

/** A few simple details that describe the user's history */
export interface IBasicUserHistoryDto {
    /** The date/time that this user was initially created */
    creationDate?: Date;
    /** The date/time that this user last made a payment */
    lastPaymentDate?: Date;

    [key: string]: any;
}

/** Results of filtering users */
export class FilteredUsersResponseDto implements IFilteredUsersResponseDto {
    results?: UserProfileDto[];
    /** The total number of users returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;

    constructor(data?: IFilteredUsersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserProfileDto.fromJS(item));
            }
            this.totalResults = _data["totalResults"];
        }
    }

    static fromJS(data: any): FilteredUsersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredUsersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalResults"] = this.totalResults;
        return data;
    }
}

/** Results of filtering users */
export interface IFilteredUsersResponseDto {
    results?: UserProfileDto[];
    /** The total number of users returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;
}

/** Results of filtering unconfirmed users */
export class FilteredUnconfirmedUsersResponseDto implements IFilteredUnconfirmedUsersResponseDto {
    results?: UnconfirmedUserDto[];
    /** The total number of unconfirmed users returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;

    constructor(data?: IFilteredUnconfirmedUsersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UnconfirmedUserDto.fromJS(item));
            }
            this.totalResults = _data["totalResults"];
        }
    }

    static fromJS(data: any): FilteredUnconfirmedUsersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredUnconfirmedUsersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalResults"] = this.totalResults;
        return data;
    }
}

/** Results of filtering unconfirmed users */
export interface IFilteredUnconfirmedUsersResponseDto {
    results?: UnconfirmedUserDto[];
    /** The total number of unconfirmed users returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;
}

export class UnconfirmedUserDto implements IUnconfirmedUserDto {
    /** Full name of the user (if available) */
    name?: string;
    /** Email of the user (if available) */
    email?: string;
    /** The date/time that the user was created */
    createdDate?: Date;

    [key: string]: any;

    constructor(data?: IUnconfirmedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.email = _data["email"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnconfirmedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnconfirmedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["email"] = this.email;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnconfirmedUserDto {
    /** Full name of the user (if available) */
    name?: string;
    /** Email of the user (if available) */
    email?: string;
    /** The date/time that the user was created */
    createdDate?: Date;

    [key: string]: any;
}

/** Results of filtering payment events */
export class FilteredPaymentActivityResponseDto implements IFilteredPaymentActivityResponseDto {
    results?: ActivityLogDto[];
    totalResults?: number;

    [key: string]: any;

    constructor(data?: IFilteredPaymentActivityResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActivityLogDto.fromJS(item));
            }
            this.totalResults = _data["totalResults"];
        }
    }

    static fromJS(data: any): FilteredPaymentActivityResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredPaymentActivityResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalResults"] = this.totalResults;
        return data;
    }
}

/** Results of filtering payment events */
export interface IFilteredPaymentActivityResponseDto {
    results?: ActivityLogDto[];
    totalResults?: number;

    [key: string]: any;
}

/** Response for inbound redirect sources */
export class InboundRedirectSourceListResponseDto implements IInboundRedirectSourceListResponseDto {
    items?: InboundRedirectSourceDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IInboundRedirectSourceListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InboundRedirectSourceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InboundRedirectSourceListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboundRedirectSourceListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for inbound redirect sources */
export interface IInboundRedirectSourceListResponseDto {
    items?: InboundRedirectSourceDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Inbound redirect source entity */
export class InboundRedirectSourceDto implements IInboundRedirectSourceDto {
    id?: number;
    configNo?: number;
    sourceKey?: number;
    /** Unique alias used in the URL for routing inbound redirects */
    alias?: string;
    securityKey?: string;
    paymentOptionType?: string;
    active?: boolean;
    parameterFormat?: number;
    label?: string;
    showErrorDialog?: boolean;
    cancelUrl?: string;
    errorUrl?: string;
    successUrl?: string;
    pageId?: number;
    allowCartItemDetailsPage?: boolean;
    skipReceiptPage?: boolean;
    dontSendReceiptEmail?: boolean;

    [key: string]: any;

    constructor(data?: IInboundRedirectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.configNo = _data["configNo"];
            this.sourceKey = _data["sourceKey"];
            this.alias = _data["alias"];
            this.securityKey = _data["securityKey"];
            this.paymentOptionType = _data["paymentOptionType"];
            this.active = _data["active"];
            this.parameterFormat = _data["parameterFormat"];
            this.label = _data["label"];
            this.showErrorDialog = _data["showErrorDialog"];
            this.cancelUrl = _data["cancelUrl"];
            this.errorUrl = _data["errorUrl"];
            this.successUrl = _data["successUrl"];
            this.pageId = _data["pageId"];
            this.allowCartItemDetailsPage = _data["allowCartItemDetailsPage"];
            this.skipReceiptPage = _data["skipReceiptPage"];
            this.dontSendReceiptEmail = _data["dontSendReceiptEmail"];
        }
    }

    static fromJS(data: any): InboundRedirectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InboundRedirectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["configNo"] = this.configNo;
        data["sourceKey"] = this.sourceKey;
        data["alias"] = this.alias;
        data["securityKey"] = this.securityKey;
        data["paymentOptionType"] = this.paymentOptionType;
        data["active"] = this.active;
        data["parameterFormat"] = this.parameterFormat;
        data["label"] = this.label;
        data["showErrorDialog"] = this.showErrorDialog;
        data["cancelUrl"] = this.cancelUrl;
        data["errorUrl"] = this.errorUrl;
        data["successUrl"] = this.successUrl;
        data["pageId"] = this.pageId;
        data["allowCartItemDetailsPage"] = this.allowCartItemDetailsPage;
        data["skipReceiptPage"] = this.skipReceiptPage;
        data["dontSendReceiptEmail"] = this.dontSendReceiptEmail;
        return data;
    }
}

/** Inbound redirect source entity */
export interface IInboundRedirectSourceDto {
    id?: number;
    configNo?: number;
    sourceKey?: number;
    /** Unique alias used in the URL for routing inbound redirects */
    alias?: string;
    securityKey?: string;
    paymentOptionType?: string;
    active?: boolean;
    parameterFormat?: number;
    label?: string;
    showErrorDialog?: boolean;
    cancelUrl?: string;
    errorUrl?: string;
    successUrl?: string;
    pageId?: number;
    allowCartItemDetailsPage?: boolean;
    skipReceiptPage?: boolean;
    dontSendReceiptEmail?: boolean;

    [key: string]: any;
}

/** DTO for creating a new inbound redirect source */
export class CreateInboundRedirectSourceDto implements ICreateInboundRedirectSourceDto {
    configNo?: number;
    sourceKey?: number;
    /** Unique alias used in the URL for routing inbound redirects */
    alias?: string;
    securityKey?: string;
    paymentOptionType?: string;
    active?: boolean;
    parameterFormat?: number;
    label?: string;
    showErrorDialog?: boolean;
    cancelUrl?: string;
    errorUrl?: string;
    successUrl?: string;
    pageId?: number;
    allowCartItemDetailsPage?: boolean;
    skipReceiptPage?: boolean;
    dontSendReceiptEmail?: boolean;

    [key: string]: any;

    constructor(data?: ICreateInboundRedirectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.sourceKey = _data["sourceKey"];
            this.alias = _data["alias"];
            this.securityKey = _data["securityKey"];
            this.paymentOptionType = _data["paymentOptionType"];
            this.active = _data["active"];
            this.parameterFormat = _data["parameterFormat"];
            this.label = _data["label"];
            this.showErrorDialog = _data["showErrorDialog"];
            this.cancelUrl = _data["cancelUrl"];
            this.errorUrl = _data["errorUrl"];
            this.successUrl = _data["successUrl"];
            this.pageId = _data["pageId"];
            this.allowCartItemDetailsPage = _data["allowCartItemDetailsPage"];
            this.skipReceiptPage = _data["skipReceiptPage"];
            this.dontSendReceiptEmail = _data["dontSendReceiptEmail"];
        }
    }

    static fromJS(data: any): CreateInboundRedirectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInboundRedirectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["sourceKey"] = this.sourceKey;
        data["alias"] = this.alias;
        data["securityKey"] = this.securityKey;
        data["paymentOptionType"] = this.paymentOptionType;
        data["active"] = this.active;
        data["parameterFormat"] = this.parameterFormat;
        data["label"] = this.label;
        data["showErrorDialog"] = this.showErrorDialog;
        data["cancelUrl"] = this.cancelUrl;
        data["errorUrl"] = this.errorUrl;
        data["successUrl"] = this.successUrl;
        data["pageId"] = this.pageId;
        data["allowCartItemDetailsPage"] = this.allowCartItemDetailsPage;
        data["skipReceiptPage"] = this.skipReceiptPage;
        data["dontSendReceiptEmail"] = this.dontSendReceiptEmail;
        return data;
    }
}

/** DTO for creating a new inbound redirect source */
export interface ICreateInboundRedirectSourceDto {
    configNo?: number;
    sourceKey?: number;
    /** Unique alias used in the URL for routing inbound redirects */
    alias?: string;
    securityKey?: string;
    paymentOptionType?: string;
    active?: boolean;
    parameterFormat?: number;
    label?: string;
    showErrorDialog?: boolean;
    cancelUrl?: string;
    errorUrl?: string;
    successUrl?: string;
    pageId?: number;
    allowCartItemDetailsPage?: boolean;
    skipReceiptPage?: boolean;
    dontSendReceiptEmail?: boolean;

    [key: string]: any;
}

/** DTO for updating an inbound redirect source */
export class UpdateInboundRedirectSourceDto implements IUpdateInboundRedirectSourceDto {
    configNo!: number;
    sourceKey?: number;
    /** Unique alias used in the URL for routing inbound redirects */
    alias?: string;
    securityKey?: string;
    paymentOptionType?: string;
    active?: boolean;
    parameterFormat?: number;
    label?: string;
    showErrorDialog?: boolean;
    cancelUrl?: string;
    errorUrl?: string;
    successUrl?: string;
    pageId?: number;
    allowCartItemDetailsPage?: boolean;
    skipReceiptPage?: boolean;
    dontSendReceiptEmail?: boolean;

    [key: string]: any;

    constructor(data?: IUpdateInboundRedirectSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.sourceKey = _data["sourceKey"];
            this.alias = _data["alias"];
            this.securityKey = _data["securityKey"];
            this.paymentOptionType = _data["paymentOptionType"];
            this.active = _data["active"];
            this.parameterFormat = _data["parameterFormat"];
            this.label = _data["label"];
            this.showErrorDialog = _data["showErrorDialog"];
            this.cancelUrl = _data["cancelUrl"];
            this.errorUrl = _data["errorUrl"];
            this.successUrl = _data["successUrl"];
            this.pageId = _data["pageId"];
            this.allowCartItemDetailsPage = _data["allowCartItemDetailsPage"];
            this.skipReceiptPage = _data["skipReceiptPage"];
            this.dontSendReceiptEmail = _data["dontSendReceiptEmail"];
        }
    }

    static fromJS(data: any): UpdateInboundRedirectSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInboundRedirectSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["sourceKey"] = this.sourceKey;
        data["alias"] = this.alias;
        data["securityKey"] = this.securityKey;
        data["paymentOptionType"] = this.paymentOptionType;
        data["active"] = this.active;
        data["parameterFormat"] = this.parameterFormat;
        data["label"] = this.label;
        data["showErrorDialog"] = this.showErrorDialog;
        data["cancelUrl"] = this.cancelUrl;
        data["errorUrl"] = this.errorUrl;
        data["successUrl"] = this.successUrl;
        data["pageId"] = this.pageId;
        data["allowCartItemDetailsPage"] = this.allowCartItemDetailsPage;
        data["skipReceiptPage"] = this.skipReceiptPage;
        data["dontSendReceiptEmail"] = this.dontSendReceiptEmail;
        return data;
    }
}

/** DTO for updating an inbound redirect source */
export interface IUpdateInboundRedirectSourceDto {
    configNo: number;
    sourceKey?: number;
    /** Unique alias used in the URL for routing inbound redirects */
    alias?: string;
    securityKey?: string;
    paymentOptionType?: string;
    active?: boolean;
    parameterFormat?: number;
    label?: string;
    showErrorDialog?: boolean;
    cancelUrl?: string;
    errorUrl?: string;
    successUrl?: string;
    pageId?: number;
    allowCartItemDetailsPage?: boolean;
    skipReceiptPage?: boolean;
    dontSendReceiptEmail?: boolean;

    [key: string]: any;
}

/** Response for email templates */
export class EmailTemplateListResponseDto implements IEmailTemplateListResponseDto {
    items?: EmailTemplateDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IEmailTemplateListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmailTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmailTemplateListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for email templates */
export interface IEmailTemplateListResponseDto {
    items?: EmailTemplateDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Email template entity */
export class EmailTemplateDto implements IEmailTemplateDto {
    id?: number;
    name?: number;
    nameDisplay?: string;
    subject?: string;
    bodyHTML?: string;
    snippet?: string;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameDisplay = _data["nameDisplay"];
            this.subject = _data["subject"];
            this.bodyHTML = _data["bodyHTML"];
            this.snippet = _data["snippet"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameDisplay"] = this.nameDisplay;
        data["subject"] = this.subject;
        data["bodyHTML"] = this.bodyHTML;
        data["snippet"] = this.snippet;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** Email template entity */
export interface IEmailTemplateDto {
    id?: number;
    name?: number;
    nameDisplay?: string;
    subject?: string;
    bodyHTML?: string;
    snippet?: string;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** Email template name option for dropdown selection */
export class EmailTemplateNameOptionDto implements IEmailTemplateNameOptionDto {
    value?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IEmailTemplateNameOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmailTemplateNameOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateNameOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

/** Email template name option for dropdown selection */
export interface IEmailTemplateNameOptionDto {
    value?: number;
    name?: string;

    [key: string]: any;
}

/** DTO for creating a new email template */
export class CreateEmailTemplateDto implements ICreateEmailTemplateDto {
    name?: number;
    subject?: string;
    bodyHTML?: string;
    snippet?: string;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: ICreateEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.bodyHTML = _data["bodyHTML"];
            this.snippet = _data["snippet"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["bodyHTML"] = this.bodyHTML;
        data["snippet"] = this.snippet;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for creating a new email template */
export interface ICreateEmailTemplateDto {
    name?: number;
    subject?: string;
    bodyHTML?: string;
    snippet?: string;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for updating an email template */
export class UpdateEmailTemplateDto implements IUpdateEmailTemplateDto {
    name?: number;
    subject?: string;
    bodyHTML?: string;
    snippet?: string;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IUpdateEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.bodyHTML = _data["bodyHTML"];
            this.snippet = _data["snippet"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["bodyHTML"] = this.bodyHTML;
        data["snippet"] = this.snippet;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for updating an email template */
export interface IUpdateEmailTemplateDto {
    name?: number;
    subject?: string;
    bodyHTML?: string;
    snippet?: string;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** Response for pages */
export class PageListResponseDto implements IPageListResponseDto {
    items?: PageDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IPageListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PageListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for pages */
export interface IPageListResponseDto {
    items?: PageDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Page entity */
export class PageDto implements IPageDto {
    id?: number;
    configNo?: number;
    tellerBusinessSystemNo?: number | undefined;
    header?: string;
    description?: string;
    paginatedResults?: boolean;
    active?: boolean;
    paymentProcessorConfigKey?: string;
    tellerConnectionId?: number;
    publicPortalSiteId?: number;
    scheduledPaymentsEnabled?: boolean;
    scheduledPaymentTellerConnectionId?: number | undefined;
    scheduledPaymentTellerBusinessSystemNo?: number | undefined;
    /** Per-method availability overrides for this page. An empty array clears them and returns the page to inheriting its connection's availability. */
    tenderOverrides?: PageTenderOverrideDto[];

    [key: string]: any;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.configNo = _data["configNo"];
            this.tellerBusinessSystemNo = _data["tellerBusinessSystemNo"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.paginatedResults = _data["paginatedResults"];
            this.active = _data["active"];
            this.paymentProcessorConfigKey = _data["paymentProcessorConfigKey"];
            this.tellerConnectionId = _data["tellerConnectionId"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
            this.scheduledPaymentsEnabled = _data["scheduledPaymentsEnabled"];
            this.scheduledPaymentTellerConnectionId = _data["scheduledPaymentTellerConnectionId"];
            this.scheduledPaymentTellerBusinessSystemNo = _data["scheduledPaymentTellerBusinessSystemNo"];
            if (Array.isArray(_data["tenderOverrides"])) {
                this.tenderOverrides = [] as any;
                for (let item of _data["tenderOverrides"])
                    this.tenderOverrides!.push(PageTenderOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["configNo"] = this.configNo;
        data["tellerBusinessSystemNo"] = this.tellerBusinessSystemNo;
        data["header"] = this.header;
        data["description"] = this.description;
        data["paginatedResults"] = this.paginatedResults;
        data["active"] = this.active;
        data["paymentProcessorConfigKey"] = this.paymentProcessorConfigKey;
        data["tellerConnectionId"] = this.tellerConnectionId;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        data["scheduledPaymentsEnabled"] = this.scheduledPaymentsEnabled;
        data["scheduledPaymentTellerConnectionId"] = this.scheduledPaymentTellerConnectionId;
        data["scheduledPaymentTellerBusinessSystemNo"] = this.scheduledPaymentTellerBusinessSystemNo;
        if (Array.isArray(this.tenderOverrides)) {
            data["tenderOverrides"] = [];
            for (let item of this.tenderOverrides)
                data["tenderOverrides"].push(item.toJSON());
        }
        return data;
    }
}

/** Page entity */
export interface IPageDto {
    id?: number;
    configNo?: number;
    tellerBusinessSystemNo?: number | undefined;
    header?: string;
    description?: string;
    paginatedResults?: boolean;
    active?: boolean;
    paymentProcessorConfigKey?: string;
    tellerConnectionId?: number;
    publicPortalSiteId?: number;
    scheduledPaymentsEnabled?: boolean;
    scheduledPaymentTellerConnectionId?: number | undefined;
    scheduledPaymentTellerBusinessSystemNo?: number | undefined;
    /** Per-method availability overrides for this page. An empty array clears them and returns the page to inheriting its connection's availability. */
    tenderOverrides?: PageTenderOverrideDto[];

    [key: string]: any;
}

/** DTO for creating a new page */
export class CreatePageDto implements ICreatePageDto {
    configNo?: number;
    tellerBusinessSystemNo?: number | undefined;
    header?: string;
    description?: string;
    paginatedResults?: boolean;
    active?: boolean;
    paymentProcessorConfigKey?: string;
    tellerConnectionId?: number;
    publicPortalSiteId?: number;
    scheduledPaymentsEnabled?: boolean;
    scheduledPaymentTellerConnectionId?: number | undefined;
    scheduledPaymentTellerBusinessSystemNo?: number | undefined;
    /** Per-method availability overrides for this page, settable as the page is created so availability does not have to wait for a second save. Omitted or empty means the page inherits its connection's availability. */
    tenderOverrides?: PageTenderOverrideDto[];

    [key: string]: any;

    constructor(data?: ICreatePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.tellerBusinessSystemNo = _data["tellerBusinessSystemNo"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.paginatedResults = _data["paginatedResults"];
            this.active = _data["active"];
            this.paymentProcessorConfigKey = _data["paymentProcessorConfigKey"];
            this.tellerConnectionId = _data["tellerConnectionId"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
            this.scheduledPaymentsEnabled = _data["scheduledPaymentsEnabled"];
            this.scheduledPaymentTellerConnectionId = _data["scheduledPaymentTellerConnectionId"];
            this.scheduledPaymentTellerBusinessSystemNo = _data["scheduledPaymentTellerBusinessSystemNo"];
            if (Array.isArray(_data["tenderOverrides"])) {
                this.tenderOverrides = [] as any;
                for (let item of _data["tenderOverrides"])
                    this.tenderOverrides!.push(PageTenderOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["tellerBusinessSystemNo"] = this.tellerBusinessSystemNo;
        data["header"] = this.header;
        data["description"] = this.description;
        data["paginatedResults"] = this.paginatedResults;
        data["active"] = this.active;
        data["paymentProcessorConfigKey"] = this.paymentProcessorConfigKey;
        data["tellerConnectionId"] = this.tellerConnectionId;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        data["scheduledPaymentsEnabled"] = this.scheduledPaymentsEnabled;
        data["scheduledPaymentTellerConnectionId"] = this.scheduledPaymentTellerConnectionId;
        data["scheduledPaymentTellerBusinessSystemNo"] = this.scheduledPaymentTellerBusinessSystemNo;
        if (Array.isArray(this.tenderOverrides)) {
            data["tenderOverrides"] = [];
            for (let item of this.tenderOverrides)
                data["tenderOverrides"].push(item.toJSON());
        }
        return data;
    }
}

/** DTO for creating a new page */
export interface ICreatePageDto {
    configNo?: number;
    tellerBusinessSystemNo?: number | undefined;
    header?: string;
    description?: string;
    paginatedResults?: boolean;
    active?: boolean;
    paymentProcessorConfigKey?: string;
    tellerConnectionId?: number;
    publicPortalSiteId?: number;
    scheduledPaymentsEnabled?: boolean;
    scheduledPaymentTellerConnectionId?: number | undefined;
    scheduledPaymentTellerBusinessSystemNo?: number | undefined;
    /** Per-method availability overrides for this page, settable as the page is created so availability does not have to wait for a second save. Omitted or empty means the page inherits its connection's availability. */
    tenderOverrides?: PageTenderOverrideDto[];

    [key: string]: any;
}

/** DTO for updating a page */
export class UpdatePageDto implements IUpdatePageDto {
    configNo!: number;
    tellerBusinessSystemNo?: number | undefined;
    header?: string;
    description?: string;
    paginatedResults?: boolean;
    active?: boolean;
    tellerConnectionId?: number;
    publicPortalSiteId?: number;
    scheduledPaymentsEnabled?: boolean;
    scheduledPaymentTellerConnectionId?: number | undefined;
    scheduledPaymentTellerBusinessSystemNo?: number | undefined;
    /** Per-method availability overrides for this page. An empty array clears them and returns the page to inheriting its connection's availability. */
    tenderOverrides?: PageTenderOverrideDto[];

    [key: string]: any;

    constructor(data?: IUpdatePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.tellerBusinessSystemNo = _data["tellerBusinessSystemNo"];
            this.header = _data["header"];
            this.description = _data["description"];
            this.paginatedResults = _data["paginatedResults"];
            this.active = _data["active"];
            this.tellerConnectionId = _data["tellerConnectionId"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
            this.scheduledPaymentsEnabled = _data["scheduledPaymentsEnabled"];
            this.scheduledPaymentTellerConnectionId = _data["scheduledPaymentTellerConnectionId"];
            this.scheduledPaymentTellerBusinessSystemNo = _data["scheduledPaymentTellerBusinessSystemNo"];
            if (Array.isArray(_data["tenderOverrides"])) {
                this.tenderOverrides = [] as any;
                for (let item of _data["tenderOverrides"])
                    this.tenderOverrides!.push(PageTenderOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["tellerBusinessSystemNo"] = this.tellerBusinessSystemNo;
        data["header"] = this.header;
        data["description"] = this.description;
        data["paginatedResults"] = this.paginatedResults;
        data["active"] = this.active;
        data["tellerConnectionId"] = this.tellerConnectionId;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        data["scheduledPaymentsEnabled"] = this.scheduledPaymentsEnabled;
        data["scheduledPaymentTellerConnectionId"] = this.scheduledPaymentTellerConnectionId;
        data["scheduledPaymentTellerBusinessSystemNo"] = this.scheduledPaymentTellerBusinessSystemNo;
        if (Array.isArray(this.tenderOverrides)) {
            data["tenderOverrides"] = [];
            for (let item of this.tenderOverrides)
                data["tenderOverrides"].push(item.toJSON());
        }
        return data;
    }
}

/** DTO for updating a page */
export interface IUpdatePageDto {
    configNo: number;
    tellerBusinessSystemNo?: number | undefined;
    header?: string;
    description?: string;
    paginatedResults?: boolean;
    active?: boolean;
    tellerConnectionId?: number;
    publicPortalSiteId?: number;
    scheduledPaymentsEnabled?: boolean;
    scheduledPaymentTellerConnectionId?: number | undefined;
    scheduledPaymentTellerBusinessSystemNo?: number | undefined;
    /** Per-method availability overrides for this page. An empty array clears them and returns the page to inheriting its connection's availability. */
    tenderOverrides?: PageTenderOverrideDto[];

    [key: string]: any;
}

/** Sets the payment processor config key on a page or teller connection. Clearing the key is a DELETE on the same endpoint, never a null here. */
export class SetPaymentProcessorConfigKeyRequestDto implements ISetPaymentProcessorConfigKeyRequestDto {
    paymentProcessorConfigKey!: string;

    [key: string]: any;

    constructor(data?: ISetPaymentProcessorConfigKeyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentProcessorConfigKey = _data["paymentProcessorConfigKey"];
        }
    }

    static fromJS(data: any): SetPaymentProcessorConfigKeyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetPaymentProcessorConfigKeyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentProcessorConfigKey"] = this.paymentProcessorConfigKey;
        return data;
    }
}

/** Sets the payment processor config key on a page or teller connection. Clearing the key is a DELETE on the same endpoint, never a null here. */
export interface ISetPaymentProcessorConfigKeyRequestDto {
    paymentProcessorConfigKey: string;

    [key: string]: any;
}

/** Response for page item types */
export class PageItemTypeListResponseDto implements IPageItemTypeListResponseDto {
    items?: PageItemTypeDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IPageItemTypeListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PageItemTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PageItemTypeListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageItemTypeListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for page item types */
export interface IPageItemTypeListResponseDto {
    items?: PageItemTypeDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Page item type entity */
export class PageItemTypeDto implements IPageItemTypeDto {
    id?: number;
    configNo?: number;
    label?: string;
    image?: string;
    internalNotificationEmail?: string;
    internalNotificationEmailTemplate?: string;
    helpText?: string;
    active?: boolean;
    tellerItemConfigNo?: number;
    pageId?: number;
    tellerId?: number | undefined;

    [key: string]: any;

    constructor(data?: IPageItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.configNo = _data["configNo"];
            this.label = _data["label"];
            this.image = _data["image"];
            this.internalNotificationEmail = _data["internalNotificationEmail"];
            this.internalNotificationEmailTemplate = _data["internalNotificationEmailTemplate"];
            this.helpText = _data["helpText"];
            this.active = _data["active"];
            this.tellerItemConfigNo = _data["tellerItemConfigNo"];
            this.pageId = _data["pageId"];
            this.tellerId = _data["tellerId"];
        }
    }

    static fromJS(data: any): PageItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["configNo"] = this.configNo;
        data["label"] = this.label;
        data["image"] = this.image;
        data["internalNotificationEmail"] = this.internalNotificationEmail;
        data["internalNotificationEmailTemplate"] = this.internalNotificationEmailTemplate;
        data["helpText"] = this.helpText;
        data["active"] = this.active;
        data["tellerItemConfigNo"] = this.tellerItemConfigNo;
        data["pageId"] = this.pageId;
        data["tellerId"] = this.tellerId;
        return data;
    }
}

/** Page item type entity */
export interface IPageItemTypeDto {
    id?: number;
    configNo?: number;
    label?: string;
    image?: string;
    internalNotificationEmail?: string;
    internalNotificationEmailTemplate?: string;
    helpText?: string;
    active?: boolean;
    tellerItemConfigNo?: number;
    pageId?: number;
    tellerId?: number | undefined;

    [key: string]: any;
}

/** DTO for creating a new page item type */
export class CreatePageItemTypeDto implements ICreatePageItemTypeDto {
    configNo?: number;
    label?: string;
    image?: string;
    internalNotificationEmail?: string;
    internalNotificationEmailTemplate?: string;
    helpText?: string;
    active?: boolean;
    tellerItemConfigNo?: number;
    pageId?: number;
    tellerId?: number | undefined;

    [key: string]: any;

    constructor(data?: ICreatePageItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.label = _data["label"];
            this.image = _data["image"];
            this.internalNotificationEmail = _data["internalNotificationEmail"];
            this.internalNotificationEmailTemplate = _data["internalNotificationEmailTemplate"];
            this.helpText = _data["helpText"];
            this.active = _data["active"];
            this.tellerItemConfigNo = _data["tellerItemConfigNo"];
            this.pageId = _data["pageId"];
            this.tellerId = _data["tellerId"];
        }
    }

    static fromJS(data: any): CreatePageItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePageItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["label"] = this.label;
        data["image"] = this.image;
        data["internalNotificationEmail"] = this.internalNotificationEmail;
        data["internalNotificationEmailTemplate"] = this.internalNotificationEmailTemplate;
        data["helpText"] = this.helpText;
        data["active"] = this.active;
        data["tellerItemConfigNo"] = this.tellerItemConfigNo;
        data["pageId"] = this.pageId;
        data["tellerId"] = this.tellerId;
        return data;
    }
}

/** DTO for creating a new page item type */
export interface ICreatePageItemTypeDto {
    configNo?: number;
    label?: string;
    image?: string;
    internalNotificationEmail?: string;
    internalNotificationEmailTemplate?: string;
    helpText?: string;
    active?: boolean;
    tellerItemConfigNo?: number;
    pageId?: number;
    tellerId?: number | undefined;

    [key: string]: any;
}

/** DTO for updating a page item type */
export class UpdatePageItemTypeDto implements IUpdatePageItemTypeDto {
    configNo!: number;
    label?: string;
    image?: string;
    internalNotificationEmail?: string;
    internalNotificationEmailTemplate?: string;
    helpText?: string;
    active?: boolean;
    tellerItemConfigNo?: number;
    pageId?: number;
    tellerId?: number | undefined;

    [key: string]: any;

    constructor(data?: IUpdatePageItemTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.label = _data["label"];
            this.image = _data["image"];
            this.internalNotificationEmail = _data["internalNotificationEmail"];
            this.internalNotificationEmailTemplate = _data["internalNotificationEmailTemplate"];
            this.helpText = _data["helpText"];
            this.active = _data["active"];
            this.tellerItemConfigNo = _data["tellerItemConfigNo"];
            this.pageId = _data["pageId"];
            this.tellerId = _data["tellerId"];
        }
    }

    static fromJS(data: any): UpdatePageItemTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePageItemTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["label"] = this.label;
        data["image"] = this.image;
        data["internalNotificationEmail"] = this.internalNotificationEmail;
        data["internalNotificationEmailTemplate"] = this.internalNotificationEmailTemplate;
        data["helpText"] = this.helpText;
        data["active"] = this.active;
        data["tellerItemConfigNo"] = this.tellerItemConfigNo;
        data["pageId"] = this.pageId;
        data["tellerId"] = this.tellerId;
        return data;
    }
}

/** DTO for updating a page item type */
export interface IUpdatePageItemTypeDto {
    configNo: number;
    label?: string;
    image?: string;
    internalNotificationEmail?: string;
    internalNotificationEmailTemplate?: string;
    helpText?: string;
    active?: boolean;
    tellerItemConfigNo?: number;
    pageId?: number;
    tellerId?: number | undefined;

    [key: string]: any;
}

/** Response for portal features */
export class ConfigPortalFeatureListResponseDto implements IConfigPortalFeatureListResponseDto {
    items?: ConfigPortalFeatureDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IConfigPortalFeatureListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConfigPortalFeatureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ConfigPortalFeatureListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigPortalFeatureListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for portal features */
export interface IConfigPortalFeatureListResponseDto {
    items?: ConfigPortalFeatureDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Portal feature entity */
export class ConfigPortalFeatureDto implements IConfigPortalFeatureDto {
    id?: number;
    name?: string;
    enabled?: boolean;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IConfigPortalFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): ConfigPortalFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigPortalFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** Portal feature entity */
export interface IConfigPortalFeatureDto {
    id?: number;
    name?: string;
    enabled?: boolean;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for creating a new portal feature */
export class CreateConfigPortalFeatureDto implements ICreateConfigPortalFeatureDto {
    name?: string;
    enabled?: boolean;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: ICreateConfigPortalFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): CreateConfigPortalFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigPortalFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for creating a new portal feature */
export interface ICreateConfigPortalFeatureDto {
    name?: string;
    enabled?: boolean;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for updating a portal feature */
export class UpdateConfigPortalFeatureDto implements IUpdateConfigPortalFeatureDto {
    name?: string;
    enabled?: boolean;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IUpdateConfigPortalFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): UpdateConfigPortalFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigPortalFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for updating a portal feature */
export interface IUpdateConfigPortalFeatureDto {
    name?: string;
    enabled?: boolean;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** Response for public portal sites */
export class PublicPortalSiteListResponseDto implements IPublicPortalSiteListResponseDto {
    items?: PublicPortalSiteDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IPublicPortalSiteListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PublicPortalSiteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PublicPortalSiteListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPortalSiteListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for public portal sites */
export interface IPublicPortalSiteListResponseDto {
    items?: PublicPortalSiteDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Public portal site entity */
export class PublicPortalSiteDto implements IPublicPortalSiteDto {
    id?: number;
    tenantName?: string;
    title?: string;
    subtitle?: string;
    copyrightText?: string;
    footerLinksContent?: string;
    homeBannerContent?: string;
    fromEmailDisplay?: string;
    emailFooterHTML?: string;
    sessionEndTime?: string;
    cartDisclaimer?: string;
    multiPaymentDisclaimer?: string;
    /** When true, the payment authorization disclosure is presented in a modal instead of inline above the submit button. */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationECheck?: boolean;
    defaultCountryCode?: string;
    defaultStateCode?: string;

    [key: string]: any;

    constructor(data?: IPublicPortalSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.tenantName = _data["tenantName"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.copyrightText = _data["copyrightText"];
            this.footerLinksContent = _data["footerLinksContent"];
            this.homeBannerContent = _data["homeBannerContent"];
            this.fromEmailDisplay = _data["fromEmailDisplay"];
            this.emailFooterHTML = _data["emailFooterHTML"];
            this.sessionEndTime = _data["sessionEndTime"];
            this.cartDisclaimer = _data["cartDisclaimer"];
            this.multiPaymentDisclaimer = _data["multiPaymentDisclaimer"];
            this.presentConsentInModal = _data["presentConsentInModal"];
            this.requireSavedMethodReauthorizationCreditCard = _data["requireSavedMethodReauthorizationCreditCard"];
            this.requireSavedMethodReauthorizationECheck = _data["requireSavedMethodReauthorizationECheck"];
            this.defaultCountryCode = _data["defaultCountryCode"];
            this.defaultStateCode = _data["defaultStateCode"];
        }
    }

    static fromJS(data: any): PublicPortalSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPortalSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["tenantName"] = this.tenantName;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["copyrightText"] = this.copyrightText;
        data["footerLinksContent"] = this.footerLinksContent;
        data["homeBannerContent"] = this.homeBannerContent;
        data["fromEmailDisplay"] = this.fromEmailDisplay;
        data["emailFooterHTML"] = this.emailFooterHTML;
        data["sessionEndTime"] = this.sessionEndTime;
        data["cartDisclaimer"] = this.cartDisclaimer;
        data["multiPaymentDisclaimer"] = this.multiPaymentDisclaimer;
        data["presentConsentInModal"] = this.presentConsentInModal;
        data["requireSavedMethodReauthorizationCreditCard"] = this.requireSavedMethodReauthorizationCreditCard;
        data["requireSavedMethodReauthorizationECheck"] = this.requireSavedMethodReauthorizationECheck;
        data["defaultCountryCode"] = this.defaultCountryCode;
        data["defaultStateCode"] = this.defaultStateCode;
        return data;
    }
}

/** Public portal site entity */
export interface IPublicPortalSiteDto {
    id?: number;
    tenantName?: string;
    title?: string;
    subtitle?: string;
    copyrightText?: string;
    footerLinksContent?: string;
    homeBannerContent?: string;
    fromEmailDisplay?: string;
    emailFooterHTML?: string;
    sessionEndTime?: string;
    cartDisclaimer?: string;
    multiPaymentDisclaimer?: string;
    /** When true, the payment authorization disclosure is presented in a modal instead of inline above the submit button. */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationECheck?: boolean;
    defaultCountryCode?: string;
    defaultStateCode?: string;

    [key: string]: any;
}

/** DTO for creating a new public portal site */
export class CreatePublicPortalSiteDto implements ICreatePublicPortalSiteDto {
    tenantName?: string;
    title?: string;
    subtitle?: string;
    copyrightText?: string;
    footerLinksContent?: string;
    homeBannerContent?: string;
    fromEmailDisplay?: string;
    emailFooterHTML?: string;
    sessionEndTime?: string;
    cartDisclaimer?: string;
    multiPaymentDisclaimer?: string;
    /** When true, the payment authorization disclosure is presented in a modal instead of inline above the submit button. */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationECheck?: boolean;
    defaultCountryCode?: string;
    defaultStateCode?: string;

    [key: string]: any;

    constructor(data?: ICreatePublicPortalSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tenantName = _data["tenantName"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.copyrightText = _data["copyrightText"];
            this.footerLinksContent = _data["footerLinksContent"];
            this.homeBannerContent = _data["homeBannerContent"];
            this.fromEmailDisplay = _data["fromEmailDisplay"];
            this.emailFooterHTML = _data["emailFooterHTML"];
            this.sessionEndTime = _data["sessionEndTime"];
            this.cartDisclaimer = _data["cartDisclaimer"];
            this.multiPaymentDisclaimer = _data["multiPaymentDisclaimer"];
            this.presentConsentInModal = _data["presentConsentInModal"];
            this.requireSavedMethodReauthorizationCreditCard = _data["requireSavedMethodReauthorizationCreditCard"];
            this.requireSavedMethodReauthorizationECheck = _data["requireSavedMethodReauthorizationECheck"];
            this.defaultCountryCode = _data["defaultCountryCode"];
            this.defaultStateCode = _data["defaultStateCode"];
        }
    }

    static fromJS(data: any): CreatePublicPortalSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePublicPortalSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tenantName"] = this.tenantName;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["copyrightText"] = this.copyrightText;
        data["footerLinksContent"] = this.footerLinksContent;
        data["homeBannerContent"] = this.homeBannerContent;
        data["fromEmailDisplay"] = this.fromEmailDisplay;
        data["emailFooterHTML"] = this.emailFooterHTML;
        data["sessionEndTime"] = this.sessionEndTime;
        data["cartDisclaimer"] = this.cartDisclaimer;
        data["multiPaymentDisclaimer"] = this.multiPaymentDisclaimer;
        data["presentConsentInModal"] = this.presentConsentInModal;
        data["requireSavedMethodReauthorizationCreditCard"] = this.requireSavedMethodReauthorizationCreditCard;
        data["requireSavedMethodReauthorizationECheck"] = this.requireSavedMethodReauthorizationECheck;
        data["defaultCountryCode"] = this.defaultCountryCode;
        data["defaultStateCode"] = this.defaultStateCode;
        return data;
    }
}

/** DTO for creating a new public portal site */
export interface ICreatePublicPortalSiteDto {
    tenantName?: string;
    title?: string;
    subtitle?: string;
    copyrightText?: string;
    footerLinksContent?: string;
    homeBannerContent?: string;
    fromEmailDisplay?: string;
    emailFooterHTML?: string;
    sessionEndTime?: string;
    cartDisclaimer?: string;
    multiPaymentDisclaimer?: string;
    /** When true, the payment authorization disclosure is presented in a modal instead of inline above the submit button. */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationECheck?: boolean;
    defaultCountryCode?: string;
    defaultStateCode?: string;

    [key: string]: any;
}

/** DTO for updating a public portal site */
export class UpdatePublicPortalSiteDto implements IUpdatePublicPortalSiteDto {
    tenantName?: string;
    title?: string;
    subtitle?: string;
    copyrightText?: string;
    footerLinksContent?: string;
    homeBannerContent?: string;
    fromEmailDisplay?: string;
    emailFooterHTML?: string;
    sessionEndTime?: string;
    cartDisclaimer?: string;
    multiPaymentDisclaimer?: string;
    /** When true, the payment authorization disclosure is presented in a modal instead of inline above the submit button. */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationECheck?: boolean;
    defaultCountryCode?: string;
    defaultStateCode?: string;

    [key: string]: any;

    constructor(data?: IUpdatePublicPortalSiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tenantName = _data["tenantName"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.copyrightText = _data["copyrightText"];
            this.footerLinksContent = _data["footerLinksContent"];
            this.homeBannerContent = _data["homeBannerContent"];
            this.fromEmailDisplay = _data["fromEmailDisplay"];
            this.emailFooterHTML = _data["emailFooterHTML"];
            this.sessionEndTime = _data["sessionEndTime"];
            this.cartDisclaimer = _data["cartDisclaimer"];
            this.multiPaymentDisclaimer = _data["multiPaymentDisclaimer"];
            this.presentConsentInModal = _data["presentConsentInModal"];
            this.requireSavedMethodReauthorizationCreditCard = _data["requireSavedMethodReauthorizationCreditCard"];
            this.requireSavedMethodReauthorizationECheck = _data["requireSavedMethodReauthorizationECheck"];
            this.defaultCountryCode = _data["defaultCountryCode"];
            this.defaultStateCode = _data["defaultStateCode"];
        }
    }

    static fromJS(data: any): UpdatePublicPortalSiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePublicPortalSiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tenantName"] = this.tenantName;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["copyrightText"] = this.copyrightText;
        data["footerLinksContent"] = this.footerLinksContent;
        data["homeBannerContent"] = this.homeBannerContent;
        data["fromEmailDisplay"] = this.fromEmailDisplay;
        data["emailFooterHTML"] = this.emailFooterHTML;
        data["sessionEndTime"] = this.sessionEndTime;
        data["cartDisclaimer"] = this.cartDisclaimer;
        data["multiPaymentDisclaimer"] = this.multiPaymentDisclaimer;
        data["presentConsentInModal"] = this.presentConsentInModal;
        data["requireSavedMethodReauthorizationCreditCard"] = this.requireSavedMethodReauthorizationCreditCard;
        data["requireSavedMethodReauthorizationECheck"] = this.requireSavedMethodReauthorizationECheck;
        data["defaultCountryCode"] = this.defaultCountryCode;
        data["defaultStateCode"] = this.defaultStateCode;
        return data;
    }
}

/** DTO for updating a public portal site */
export interface IUpdatePublicPortalSiteDto {
    tenantName?: string;
    title?: string;
    subtitle?: string;
    copyrightText?: string;
    footerLinksContent?: string;
    homeBannerContent?: string;
    fromEmailDisplay?: string;
    emailFooterHTML?: string;
    sessionEndTime?: string;
    cartDisclaimer?: string;
    multiPaymentDisclaimer?: string;
    /** When true, the payment authorization disclosure is presented in a modal instead of inline above the submit button. */
    presentConsentInModal?: boolean;
    /** When true, paying with a saved credit card requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationCreditCard?: boolean;
    /** When true, paying with a saved eCheck requires per-payment authorization consent; when false the save-time authorization covers future payments. */
    requireSavedMethodReauthorizationECheck?: boolean;
    defaultCountryCode?: string;
    defaultStateCode?: string;

    [key: string]: any;
}

/** Response for SMS templates */
export class SMSTemplateListResponseDto implements ISMSTemplateListResponseDto {
    items?: SMSTemplateDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: ISMSTemplateListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SMSTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SMSTemplateListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSTemplateListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for SMS templates */
export interface ISMSTemplateListResponseDto {
    items?: SMSTemplateDto[];
    totalCount?: number;

    [key: string]: any;
}

/** SMS template entity */
export class SMSTemplateDto implements ISMSTemplateDto {
    id?: number;
    name?: number;
    nameDisplay?: string;
    bodyTemplate?: string;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: ISMSTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameDisplay = _data["nameDisplay"];
            this.bodyTemplate = _data["bodyTemplate"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): SMSTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameDisplay"] = this.nameDisplay;
        data["bodyTemplate"] = this.bodyTemplate;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** SMS template entity */
export interface ISMSTemplateDto {
    id?: number;
    name?: number;
    nameDisplay?: string;
    bodyTemplate?: string;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** SMS template name option for dropdown selection */
export class SMSTemplateNameOptionDto implements ISMSTemplateNameOptionDto {
    value?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: ISMSTemplateNameOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SMSTemplateNameOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSTemplateNameOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

/** SMS template name option for dropdown selection */
export interface ISMSTemplateNameOptionDto {
    value?: number;
    name?: string;

    [key: string]: any;
}

/** DTO for creating a new SMS template */
export class CreateSMSTemplateDto implements ICreateSMSTemplateDto {
    name?: number;
    bodyTemplate?: string;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: ICreateSMSTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.bodyTemplate = _data["bodyTemplate"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): CreateSMSTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSMSTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["bodyTemplate"] = this.bodyTemplate;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for creating a new SMS template */
export interface ICreateSMSTemplateDto {
    name?: number;
    bodyTemplate?: string;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for updating an SMS template */
export class UpdateSMSTemplateDto implements IUpdateSMSTemplateDto {
    name?: number;
    bodyTemplate?: string;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IUpdateSMSTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.bodyTemplate = _data["bodyTemplate"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): UpdateSMSTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSMSTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["bodyTemplate"] = this.bodyTemplate;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for updating an SMS template */
export interface IUpdateSMSTemplateDto {
    name?: number;
    bodyTemplate?: string;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** Response for search types */
export class SearchTypeListResponseDto implements ISearchTypeListResponseDto {
    items?: SearchTypeDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: ISearchTypeListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SearchTypeListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTypeListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for search types */
export interface ISearchTypeListResponseDto {
    items?: SearchTypeDto[];
    totalCount?: number;

    [key: string]: any;
}

/** DTO for creating a new search type */
export class CreateSearchTypeDto implements ICreateSearchTypeDto {
    configNo?: number;
    tellerFetchTypeName?: string;
    label?: string;
    instructionsTitle?: string;
    instructionsText?: string;
    instructionsImage?: string;
    instructionsImageAltText?: string;
    active?: boolean;
    pageId?: number;
    template?: string;
    isLookaheadSearch?: boolean;
    lookaheadField?: string;
    flow?: number;
    loadMoreIncrement?: number;

    [key: string]: any;

    constructor(data?: ICreateSearchTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.tellerFetchTypeName = _data["tellerFetchTypeName"];
            this.label = _data["label"];
            this.instructionsTitle = _data["instructionsTitle"];
            this.instructionsText = _data["instructionsText"];
            this.instructionsImage = _data["instructionsImage"];
            this.instructionsImageAltText = _data["instructionsImageAltText"];
            this.active = _data["active"];
            this.pageId = _data["pageId"];
            this.template = _data["template"];
            this.isLookaheadSearch = _data["isLookaheadSearch"];
            this.lookaheadField = _data["lookaheadField"];
            this.flow = _data["flow"];
            this.loadMoreIncrement = _data["loadMoreIncrement"];
        }
    }

    static fromJS(data: any): CreateSearchTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSearchTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["tellerFetchTypeName"] = this.tellerFetchTypeName;
        data["label"] = this.label;
        data["instructionsTitle"] = this.instructionsTitle;
        data["instructionsText"] = this.instructionsText;
        data["instructionsImage"] = this.instructionsImage;
        data["instructionsImageAltText"] = this.instructionsImageAltText;
        data["active"] = this.active;
        data["pageId"] = this.pageId;
        data["template"] = this.template;
        data["isLookaheadSearch"] = this.isLookaheadSearch;
        data["lookaheadField"] = this.lookaheadField;
        data["flow"] = this.flow;
        data["loadMoreIncrement"] = this.loadMoreIncrement;
        return data;
    }
}

/** DTO for creating a new search type */
export interface ICreateSearchTypeDto {
    configNo?: number;
    tellerFetchTypeName?: string;
    label?: string;
    instructionsTitle?: string;
    instructionsText?: string;
    instructionsImage?: string;
    instructionsImageAltText?: string;
    active?: boolean;
    pageId?: number;
    template?: string;
    isLookaheadSearch?: boolean;
    lookaheadField?: string;
    flow?: number;
    loadMoreIncrement?: number;

    [key: string]: any;
}

/** DTO for updating a search type */
export class UpdateSearchTypeDto implements IUpdateSearchTypeDto {
    configNo!: number;
    tellerFetchTypeName?: string;
    label?: string;
    instructionsTitle?: string;
    instructionsText?: string;
    instructionsImage?: string;
    instructionsImageAltText?: string;
    active?: boolean;
    pageId?: number;
    template?: string;
    isLookaheadSearch?: boolean;
    lookaheadField?: string;
    flow?: number;
    loadMoreIncrement?: number;

    [key: string]: any;

    constructor(data?: IUpdateSearchTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.tellerFetchTypeName = _data["tellerFetchTypeName"];
            this.label = _data["label"];
            this.instructionsTitle = _data["instructionsTitle"];
            this.instructionsText = _data["instructionsText"];
            this.instructionsImage = _data["instructionsImage"];
            this.instructionsImageAltText = _data["instructionsImageAltText"];
            this.active = _data["active"];
            this.pageId = _data["pageId"];
            this.template = _data["template"];
            this.isLookaheadSearch = _data["isLookaheadSearch"];
            this.lookaheadField = _data["lookaheadField"];
            this.flow = _data["flow"];
            this.loadMoreIncrement = _data["loadMoreIncrement"];
        }
    }

    static fromJS(data: any): UpdateSearchTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSearchTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["tellerFetchTypeName"] = this.tellerFetchTypeName;
        data["label"] = this.label;
        data["instructionsTitle"] = this.instructionsTitle;
        data["instructionsText"] = this.instructionsText;
        data["instructionsImage"] = this.instructionsImage;
        data["instructionsImageAltText"] = this.instructionsImageAltText;
        data["active"] = this.active;
        data["pageId"] = this.pageId;
        data["template"] = this.template;
        data["isLookaheadSearch"] = this.isLookaheadSearch;
        data["lookaheadField"] = this.lookaheadField;
        data["flow"] = this.flow;
        data["loadMoreIncrement"] = this.loadMoreIncrement;
        return data;
    }
}

/** DTO for updating a search type */
export interface IUpdateSearchTypeDto {
    configNo: number;
    tellerFetchTypeName?: string;
    label?: string;
    instructionsTitle?: string;
    instructionsText?: string;
    instructionsImage?: string;
    instructionsImageAltText?: string;
    active?: boolean;
    pageId?: number;
    template?: string;
    isLookaheadSearch?: boolean;
    lookaheadField?: string;
    flow?: number;
    loadMoreIncrement?: number;

    [key: string]: any;
}

/** Response for teller connections */
export class TellerConnectionListResponseDto implements ITellerConnectionListResponseDto {
    items?: TellerConnectionDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: ITellerConnectionListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TellerConnectionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TellerConnectionListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerConnectionListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for teller connections */
export interface ITellerConnectionListResponseDto {
    items?: TellerConnectionDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Teller connection */
export class TellerConnectionDto implements ITellerConnectionDto {
    id?: number;
    configNo?: number;
    name?: string;
    tellerSystemCode?: string;
    tellerLocationNo?: number;
    tellerPaymentChannelNo?: number | undefined;
    sessionEndTime?: string;
    sessionNamePrefix?: string | undefined;
    /** READ-ONLY on update: updateTellerConnection ignores it. Set or clear it via the payment-processor-config-key endpoints instead. */
    paymentProcessorConfigKey?: string;
    publicPortalSiteId?: number;
    tellerId?: number | undefined;
    /** How this connection names each tender to Teller. Connection-scoped by design: one Teller payment carries one tender description, so a page-level override could not be honoured. */
    tenderTypeMappings?: TenderTypeMappingDto[];
    /** Connection-level tender limits. Bounds and enablement live only at connection scope; pages may only override availability, via tenderOverrides. */
    tenderLimits?: TenderLimitDto[];
    /** READ-ONLY. False when the site's credit path hands tender selection to the PSP's own page, where TO never sees the choice and limits cannot be enforced. The admin UI disables the limits editor and the server refuses limit writes when false. Computed live, because for Generic tenants redirect-ness is plugin configuration. */
    tenderLimitsSupported?: boolean;
    /** Read-only. The payment methods this connection's payment processor configuration already names a tender type for. A method absent here has no tender type unless this connection maps one, so the admin UI requires it rather than letting the payment fail at checkout. */
    readonly processorMappedPaymentMethods?: PaymentMethodTypeEnumDto[];
    /** Tender types reported by Teller system-info, for a validated picker. EMPTY when this Teller does not supply them (pre-7.17), in which case the admin UI must accept a typed tender type name instead. */
    availableTenderTypes?: TellerTenderTypeDto[];

    [key: string]: any;

    constructor(data?: ITellerConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.configNo = _data["configNo"];
            this.name = _data["name"];
            this.tellerSystemCode = _data["tellerSystemCode"];
            this.tellerLocationNo = _data["tellerLocationNo"];
            this.tellerPaymentChannelNo = _data["tellerPaymentChannelNo"];
            this.sessionEndTime = _data["sessionEndTime"];
            this.sessionNamePrefix = _data["sessionNamePrefix"];
            this.paymentProcessorConfigKey = _data["paymentProcessorConfigKey"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
            this.tellerId = _data["tellerId"];
            if (Array.isArray(_data["tenderTypeMappings"])) {
                this.tenderTypeMappings = [] as any;
                for (let item of _data["tenderTypeMappings"])
                    this.tenderTypeMappings!.push(TenderTypeMappingDto.fromJS(item));
            }
            if (Array.isArray(_data["tenderLimits"])) {
                this.tenderLimits = [] as any;
                for (let item of _data["tenderLimits"])
                    this.tenderLimits!.push(TenderLimitDto.fromJS(item));
            }
            this.tenderLimitsSupported = _data["tenderLimitsSupported"];
            if (Array.isArray(_data["processorMappedPaymentMethods"])) {
                (<any>this).processorMappedPaymentMethods = [] as any;
                for (let item of _data["processorMappedPaymentMethods"])
                    (<any>this).processorMappedPaymentMethods!.push(item);
            }
            if (Array.isArray(_data["availableTenderTypes"])) {
                this.availableTenderTypes = [] as any;
                for (let item of _data["availableTenderTypes"])
                    this.availableTenderTypes!.push(TellerTenderTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TellerConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["configNo"] = this.configNo;
        data["name"] = this.name;
        data["tellerSystemCode"] = this.tellerSystemCode;
        data["tellerLocationNo"] = this.tellerLocationNo;
        data["tellerPaymentChannelNo"] = this.tellerPaymentChannelNo;
        data["sessionEndTime"] = this.sessionEndTime;
        data["sessionNamePrefix"] = this.sessionNamePrefix;
        data["paymentProcessorConfigKey"] = this.paymentProcessorConfigKey;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        data["tellerId"] = this.tellerId;
        if (Array.isArray(this.tenderTypeMappings)) {
            data["tenderTypeMappings"] = [];
            for (let item of this.tenderTypeMappings)
                data["tenderTypeMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.tenderLimits)) {
            data["tenderLimits"] = [];
            for (let item of this.tenderLimits)
                data["tenderLimits"].push(item.toJSON());
        }
        data["tenderLimitsSupported"] = this.tenderLimitsSupported;
        if (Array.isArray(this.processorMappedPaymentMethods)) {
            data["processorMappedPaymentMethods"] = [];
            for (let item of this.processorMappedPaymentMethods)
                data["processorMappedPaymentMethods"].push(item);
        }
        if (Array.isArray(this.availableTenderTypes)) {
            data["availableTenderTypes"] = [];
            for (let item of this.availableTenderTypes)
                data["availableTenderTypes"].push(item.toJSON());
        }
        return data;
    }
}

/** Teller connection */
export interface ITellerConnectionDto {
    id?: number;
    configNo?: number;
    name?: string;
    tellerSystemCode?: string;
    tellerLocationNo?: number;
    tellerPaymentChannelNo?: number | undefined;
    sessionEndTime?: string;
    sessionNamePrefix?: string | undefined;
    /** READ-ONLY on update: updateTellerConnection ignores it. Set or clear it via the payment-processor-config-key endpoints instead. */
    paymentProcessorConfigKey?: string;
    publicPortalSiteId?: number;
    tellerId?: number | undefined;
    /** How this connection names each tender to Teller. Connection-scoped by design: one Teller payment carries one tender description, so a page-level override could not be honoured. */
    tenderTypeMappings?: TenderTypeMappingDto[];
    /** Connection-level tender limits. Bounds and enablement live only at connection scope; pages may only override availability, via tenderOverrides. */
    tenderLimits?: TenderLimitDto[];
    /** READ-ONLY. False when the site's credit path hands tender selection to the PSP's own page, where TO never sees the choice and limits cannot be enforced. The admin UI disables the limits editor and the server refuses limit writes when false. Computed live, because for Generic tenants redirect-ness is plugin configuration. */
    tenderLimitsSupported?: boolean;
    /** Read-only. The payment methods this connection's payment processor configuration already names a tender type for. A method absent here has no tender type unless this connection maps one, so the admin UI requires it rather than letting the payment fail at checkout. */
    processorMappedPaymentMethods?: PaymentMethodTypeEnumDto[];
    /** Tender types reported by Teller system-info, for a validated picker. EMPTY when this Teller does not supply them (pre-7.17), in which case the admin UI must accept a typed tender type name instead. */
    availableTenderTypes?: TellerTenderTypeDto[];

    [key: string]: any;
}

/** Maps a payment method, and optionally a card brand, to a Teller tender type */
export class TenderTypeMappingDto implements ITenderTypeMappingDto {
    id?: number;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Null means the Default mapping for this payment method */
    cardBrand?: string | undefined;
    /** The tender type name posted to Teller. Authoritative for posting. */
    tellerTenderTypeName?: string;
    /** Teller's stable tender type config number. The primary match key for sync and the only id-like field safe to carry between environments. */
    tellerTenderTypeNo?: number | undefined;
    /** READ-ONLY. Teller's database id, populated by sync. Environment-specific. */
    tellerTenderTypeId?: number | undefined;

    [key: string]: any;

    constructor(data?: ITenderTypeMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.cardBrand = _data["cardBrand"];
            this.tellerTenderTypeName = _data["tellerTenderTypeName"];
            this.tellerTenderTypeNo = _data["tellerTenderTypeNo"];
            this.tellerTenderTypeId = _data["tellerTenderTypeId"];
        }
    }

    static fromJS(data: any): TenderTypeMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenderTypeMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["paymentMethodType"] = this.paymentMethodType;
        data["cardBrand"] = this.cardBrand;
        data["tellerTenderTypeName"] = this.tellerTenderTypeName;
        data["tellerTenderTypeNo"] = this.tellerTenderTypeNo;
        data["tellerTenderTypeId"] = this.tellerTenderTypeId;
        return data;
    }
}

/** Maps a payment method, and optionally a card brand, to a Teller tender type */
export interface ITenderTypeMappingDto {
    id?: number;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Null means the Default mapping for this payment method */
    cardBrand?: string | undefined;
    /** The tender type name posted to Teller. Authoritative for posting. */
    tellerTenderTypeName?: string;
    /** Teller's stable tender type config number. The primary match key for sync and the only id-like field safe to carry between environments. */
    tellerTenderTypeNo?: number | undefined;
    /** READ-ONLY. Teller's database id, populated by sync. Environment-specific. */
    tellerTenderTypeId?: number | undefined;

    [key: string]: any;
}

/** Whether a payment method may be used at a scope, and between what amounts. Connection-scoped only: page scope carries availability alone, via PageTenderOverrideDto. */
export class TenderLimitDto implements ITenderLimitDto {
    id?: number;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    enabled?: boolean;
    /** Null means no floor. Compared against the partition total including its convenience fee, the same total maxAmount is compared against. */
    minAmount?: number | undefined;
    /** Null means uncapped. Compared against the partition total including its convenience fee, because the partition is what becomes a payment in Teller. */
    maxAmount?: number | undefined;

    [key: string]: any;

    constructor(data?: ITenderLimitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.enabled = _data["enabled"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
        }
    }

    static fromJS(data: any): TenderLimitDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenderLimitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["paymentMethodType"] = this.paymentMethodType;
        data["enabled"] = this.enabled;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        return data;
    }
}

/** Whether a payment method may be used at a scope, and between what amounts. Connection-scoped only: page scope carries availability alone, via PageTenderOverrideDto. */
export interface ITenderLimitDto {
    id?: number;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    enabled?: boolean;
    /** Null means no floor. Compared against the partition total including its convenience fee, the same total maxAmount is compared against. */
    minAmount?: number | undefined;
    /** Null means uncapped. Compared against the partition total including its convenience fee, because the partition is what becomes a payment in Teller. */
    maxAmount?: number | undefined;

    [key: string]: any;
}

/** A page's decision to offer or withhold a payment method, overriding its Teller Connection. The row's existence is the override; absence means the page inherits. Carries no amounts: a bound applies to a Teller payment, and a payment is partitioned by connection rather than by page. */
export class PageTenderOverrideDto implements IPageTenderOverrideDto {
    paymentMethodType?: PaymentMethodTypeEnumDto;
    enabled?: boolean;

    [key: string]: any;

    constructor(data?: IPageTenderOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodType = _data["paymentMethodType"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): PageTenderOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageTenderOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodType"] = this.paymentMethodType;
        data["enabled"] = this.enabled;
        return data;
    }
}

/** A page's decision to offer or withhold a payment method, overriding its Teller Connection. The row's existence is the override; absence means the page inherits. Carries no amounts: a bound applies to a Teller payment, and a payment is partitioned by connection rather than by page. */
export interface IPageTenderOverrideDto {
    paymentMethodType?: PaymentMethodTypeEnumDto;
    enabled?: boolean;

    [key: string]: any;
}

/** A tender type Teller reports for a system */
export class TellerTenderTypeDto implements ITellerTenderTypeDto {
    tellerTenderTypeId?: number;
    tellerTenderTypeNo?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: ITellerTenderTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerTenderTypeId = _data["tellerTenderTypeId"];
            this.tellerTenderTypeNo = _data["tellerTenderTypeNo"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TellerTenderTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TellerTenderTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerTenderTypeId"] = this.tellerTenderTypeId;
        data["tellerTenderTypeNo"] = this.tellerTenderTypeNo;
        data["name"] = this.name;
        return data;
    }
}

/** A tender type Teller reports for a system */
export interface ITellerTenderTypeDto {
    tellerTenderTypeId?: number;
    tellerTenderTypeNo?: number;
    name?: string;

    [key: string]: any;
}

/** Result of the TellerApiUser permissions check */
export class ApiUserPermissionsResultDto implements IApiUserPermissionsResultDto {
    /** The username of the TellerApiUser service account */
    tellerApiUser?: string;
    /** Error message if permissions could not be retrieved (e.g. expired password) */
    errorMessage?: string;
    systems?: ApiUserSystemPermissionDto[];

    [key: string]: any;

    constructor(data?: IApiUserPermissionsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerApiUser = _data["tellerApiUser"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(ApiUserSystemPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiUserPermissionsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiUserPermissionsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerApiUser"] = this.tellerApiUser;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        return data;
    }
}

/** Result of the TellerApiUser permissions check */
export interface IApiUserPermissionsResultDto {
    /** The username of the TellerApiUser service account */
    tellerApiUser?: string;
    /** Error message if permissions could not be retrieved (e.g. expired password) */
    errorMessage?: string;
    systems?: ApiUserSystemPermissionDto[];

    [key: string]: any;
}

/** TellerApiUser permission status for a Teller system */
export class ApiUserSystemPermissionDto implements IApiUserSystemPermissionDto {
    /** The Teller system ID */
    systemId?: number;
    /** Whether the TellerApiUser has the UseApi permission for this system */
    hasUseApi?: boolean;
    /** Whether the TellerApiUser has the ReceivePayments permission for this system */
    hasReceivePayments?: boolean;
    /** Whether the TellerApiUser has the CashIn permission (or the legacy CashInAndOut permission) for this system */
    hasCashIn?: boolean;

    [key: string]: any;

    constructor(data?: IApiUserSystemPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.systemId = _data["systemId"];
            this.hasUseApi = _data["hasUseApi"];
            this.hasReceivePayments = _data["hasReceivePayments"];
            this.hasCashIn = _data["hasCashIn"];
        }
    }

    static fromJS(data: any): ApiUserSystemPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiUserSystemPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["systemId"] = this.systemId;
        data["hasUseApi"] = this.hasUseApi;
        data["hasReceivePayments"] = this.hasReceivePayments;
        data["hasCashIn"] = this.hasCashIn;
        return data;
    }
}

/** TellerApiUser permission status for a Teller system */
export interface IApiUserSystemPermissionDto {
    /** The Teller system ID */
    systemId?: number;
    /** Whether the TellerApiUser has the UseApi permission for this system */
    hasUseApi?: boolean;
    /** Whether the TellerApiUser has the ReceivePayments permission for this system */
    hasReceivePayments?: boolean;
    /** Whether the TellerApiUser has the CashIn permission (or the legacy CashInAndOut permission) for this system */
    hasCashIn?: boolean;

    [key: string]: any;
}

/** Response for menu items query */
export class ConfigMenuItemListResponseDto implements IConfigMenuItemListResponseDto {
    items?: ConfigMenuItemDto[];
    totalCount?: number;

    [key: string]: any;

    constructor(data?: IConfigMenuItemListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConfigMenuItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ConfigMenuItemListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigMenuItemListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Response for menu items query */
export interface IConfigMenuItemListResponseDto {
    items?: ConfigMenuItemDto[];
    totalCount?: number;

    [key: string]: any;
}

/** Menu item entity */
export class ConfigMenuItemDto implements IConfigMenuItemDto {
    menuItemId?: number;
    configNo?: number;
    label?: string;
    description?: string;
    displayOrder?: number;
    active?: boolean;
    pageId?: number;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IConfigMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.menuItemId = _data["menuItemId"];
            this.configNo = _data["configNo"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.active = _data["active"];
            this.pageId = _data["pageId"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): ConfigMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["menuItemId"] = this.menuItemId;
        data["configNo"] = this.configNo;
        data["label"] = this.label;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["active"] = this.active;
        data["pageId"] = this.pageId;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** Menu item entity */
export interface IConfigMenuItemDto {
    menuItemId?: number;
    configNo?: number;
    label?: string;
    description?: string;
    displayOrder?: number;
    active?: boolean;
    pageId?: number;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for creating a new menu item */
export class CreateConfigMenuItemDto implements ICreateConfigMenuItemDto {
    configNo?: number;
    label?: string;
    description?: string;
    displayOrder?: number;
    active?: boolean;
    pageId?: number;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: ICreateConfigMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.active = _data["active"];
            this.pageId = _data["pageId"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): CreateConfigMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["label"] = this.label;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["active"] = this.active;
        data["pageId"] = this.pageId;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for creating a new menu item */
export interface ICreateConfigMenuItemDto {
    configNo?: number;
    label?: string;
    description?: string;
    displayOrder?: number;
    active?: boolean;
    pageId?: number;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for updating a menu item */
export class UpdateConfigMenuItemDto implements IUpdateConfigMenuItemDto {
    configNo!: number;
    label?: string;
    description?: string;
    displayOrder?: number;
    active?: boolean;
    pageId?: number;
    publicPortalSiteId?: number;

    [key: string]: any;

    constructor(data?: IUpdateConfigMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configNo = _data["configNo"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.active = _data["active"];
            this.pageId = _data["pageId"];
            this.publicPortalSiteId = _data["publicPortalSiteId"];
        }
    }

    static fromJS(data: any): UpdateConfigMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configNo"] = this.configNo;
        data["label"] = this.label;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["active"] = this.active;
        data["pageId"] = this.pageId;
        data["publicPortalSiteId"] = this.publicPortalSiteId;
        return data;
    }
}

/** DTO for updating a menu item */
export interface IUpdateConfigMenuItemDto {
    configNo: number;
    label?: string;
    description?: string;
    displayOrder?: number;
    active?: boolean;
    pageId?: number;
    publicPortalSiteId?: number;

    [key: string]: any;
}

/** DTO for reordering a single menu item */
export class ReorderMenuItemDto implements IReorderMenuItemDto {
    menuItemId!: number;
    displayOrder!: number;

    [key: string]: any;

    constructor(data?: IReorderMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.menuItemId = _data["menuItemId"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): ReorderMenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderMenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["menuItemId"] = this.menuItemId;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

/** DTO for reordering a single menu item */
export interface IReorderMenuItemDto {
    menuItemId: number;
    displayOrder: number;

    [key: string]: any;
}

/** DTO for batch reordering menu items */
export class ReorderMenuItemsRequestDto implements IReorderMenuItemsRequestDto {
    items!: ReorderMenuItemDto[];

    [key: string]: any;

    constructor(data?: IReorderMenuItemsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReorderMenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReorderMenuItemsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderMenuItemsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

/** DTO for batch reordering menu items */
export interface IReorderMenuItemsRequestDto {
    items: ReorderMenuItemDto[];

    [key: string]: any;
}

/** Result of uploading a single asset */
export class AssetUploadResultDto implements IAssetUploadResultDto {
    /** The S3 key (path) where the asset was stored */
    key?: string;
    /** The public URL (via CloudFront) to access the asset */
    url?: string;

    [key: string]: any;

    constructor(data?: IAssetUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.key = _data["key"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AssetUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["key"] = this.key;
        data["url"] = this.url;
        return data;
    }
}

/** Result of uploading a single asset */
export interface IAssetUploadResultDto {
    /** The S3 key (path) where the asset was stored */
    key?: string;
    /** The public URL (via CloudFront) to access the asset */
    url?: string;

    [key: string]: any;
}

/** URL information for an asset */
export class AssetUrlDto implements IAssetUrlDto {
    /** Whether the asset exists in storage */
    exists?: boolean;
    /** The public URL to access the asset, or null if it doesn't exist */
    url?: string | undefined;

    [key: string]: any;

    constructor(data?: IAssetUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.exists = _data["exists"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AssetUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["exists"] = this.exists;
        data["url"] = this.url;
        return data;
    }
}

/** URL information for an asset */
export interface IAssetUrlDto {
    /** Whether the asset exists in storage */
    exists?: boolean;
    /** The public URL to access the asset, or null if it doesn't exist */
    url?: string | undefined;

    [key: string]: any;
}

/** Result of bulk asset upload for tenant branding assets */
export class BulkAssetUploadResultDto implements IBulkAssetUploadResultDto {
    /** Result for logo.png upload, or null if not uploaded */
    logo?: AssetUploadResultDto | undefined;
    /** Result for favicon.ico upload, or null if not uploaded */
    favicon?: AssetUploadResultDto | undefined;
    /** Result for styles.css upload, or null if not uploaded */
    styles?: AssetUploadResultDto | undefined;

    [key: string]: any;

    constructor(data?: IBulkAssetUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logo = _data["logo"] ? AssetUploadResultDto.fromJS(_data["logo"]) : <any>undefined;
            this.favicon = _data["favicon"] ? AssetUploadResultDto.fromJS(_data["favicon"]) : <any>undefined;
            this.styles = _data["styles"] ? AssetUploadResultDto.fromJS(_data["styles"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkAssetUploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkAssetUploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["favicon"] = this.favicon ? this.favicon.toJSON() : <any>undefined;
        data["styles"] = this.styles ? this.styles.toJSON() : <any>undefined;
        return data;
    }
}

/** Result of bulk asset upload for tenant branding assets */
export interface IBulkAssetUploadResultDto {
    /** Result for logo.png upload, or null if not uploaded */
    logo?: AssetUploadResultDto | undefined;
    /** Result for favicon.ico upload, or null if not uploaded */
    favicon?: AssetUploadResultDto | undefined;
    /** Result for styles.css upload, or null if not uploaded */
    styles?: AssetUploadResultDto | undefined;

    [key: string]: any;
}

/** All branding assets for a PublicPortalSite */
export class AllAssetsDto implements IAllAssetsDto {
    /** Information about the logo.png asset */
    logo?: AssetUrlDto;
    /** Information about the favicon.ico asset */
    favicon?: AssetUrlDto;
    /** Information about the styles.css asset */
    styles?: AssetUrlDto;

    [key: string]: any;

    constructor(data?: IAllAssetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.logo = _data["logo"] ? AssetUrlDto.fromJS(_data["logo"]) : <any>undefined;
            this.favicon = _data["favicon"] ? AssetUrlDto.fromJS(_data["favicon"]) : <any>undefined;
            this.styles = _data["styles"] ? AssetUrlDto.fromJS(_data["styles"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AllAssetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllAssetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["favicon"] = this.favicon ? this.favicon.toJSON() : <any>undefined;
        data["styles"] = this.styles ? this.styles.toJSON() : <any>undefined;
        return data;
    }
}

/** All branding assets for a PublicPortalSite */
export interface IAllAssetsDto {
    /** Information about the logo.png asset */
    logo?: AssetUrlDto;
    /** Information about the favicon.ico asset */
    favicon?: AssetUrlDto;
    /** Information about the styles.css asset */
    styles?: AssetUrlDto;

    [key: string]: any;
}

/** Results of filtering scheduled payments */
export class FilteredScheduledPaymentsResponseDto implements IFilteredScheduledPaymentsResponseDto {
    results?: AdminScheduledPaymentOverviewDto[];
    /** The total number of scheduled payments returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;

    constructor(data?: IFilteredScheduledPaymentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AdminScheduledPaymentOverviewDto.fromJS(item));
            }
            this.totalResults = _data["totalResults"];
        }
    }

    static fromJS(data: any): FilteredScheduledPaymentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredScheduledPaymentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalResults"] = this.totalResults;
        return data;
    }
}

/** Results of filtering scheduled payments */
export interface IFilteredScheduledPaymentsResponseDto {
    results?: AdminScheduledPaymentOverviewDto[];
    /** The total number of scheduled payments returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;
}

/** Summary of a scheduled payment for the admin list */
export class AdminScheduledPaymentOverviewDto implements IAdminScheduledPaymentOverviewDto {
    /** Unique identifier */
    guid?: string;
    /** Display title of the scheduled payment */
    title?: string;
    /** Current status of the schedule */
    status?: string;
    /** Total payment amount */
    totalPaymentAmount?: number;
    /** First payment date, as ISO date "YYYY-MM-DD" */
    startDate?: string;
    /** Inclusive upper bound for scheduled instance dates, as ISO date "YYYY-MM-DD" */
    endDate?: string | undefined;
    /** Payment frequency interval */
    interval?: string;
    /** Name of the user who created the schedule */
    userName?: string | undefined;
    /** Email of the user who created the schedule */
    email?: string | undefined;
    /** Date of the next pending or active instance, as ISO date "YYYY-MM-DD" */
    nextInstanceDate?: string | undefined;
    /** Date the schedule was created */
    createdDate?: Date;

    [key: string]: any;

    constructor(data?: IAdminScheduledPaymentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.totalPaymentAmount = _data["totalPaymentAmount"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.interval = _data["interval"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.nextInstanceDate = _data["nextInstanceDate"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AdminScheduledPaymentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminScheduledPaymentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["status"] = this.status;
        data["totalPaymentAmount"] = this.totalPaymentAmount;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["interval"] = this.interval;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["nextInstanceDate"] = this.nextInstanceDate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Summary of a scheduled payment for the admin list */
export interface IAdminScheduledPaymentOverviewDto {
    /** Unique identifier */
    guid?: string;
    /** Display title of the scheduled payment */
    title?: string;
    /** Current status of the schedule */
    status?: string;
    /** Total payment amount */
    totalPaymentAmount?: number;
    /** First payment date, as ISO date "YYYY-MM-DD" */
    startDate?: string;
    /** Inclusive upper bound for scheduled instance dates, as ISO date "YYYY-MM-DD" */
    endDate?: string | undefined;
    /** Payment frequency interval */
    interval?: string;
    /** Name of the user who created the schedule */
    userName?: string | undefined;
    /** Email of the user who created the schedule */
    email?: string | undefined;
    /** Date of the next pending or active instance, as ISO date "YYYY-MM-DD" */
    nextInstanceDate?: string | undefined;
    /** Date the schedule was created */
    createdDate?: Date;

    [key: string]: any;
}

/** Full details of a scheduled payment for admin view */
export class AdminScheduledPaymentDetailDto implements IAdminScheduledPaymentDetailDto {
    /** Unique identifier */
    guid?: string;
    /** Display title of the scheduled payment */
    title?: string;
    /** Current status of the schedule */
    status?: string;
    /** Total payment amount */
    totalPaymentAmount?: number;
    /** First payment date, as ISO date "YYYY-MM-DD" */
    startDate?: string;
    /** Inclusive upper bound for scheduled instance dates, as ISO date "YYYY-MM-DD" */
    endDate?: string | undefined;
    /** Payment frequency interval */
    interval?: string;
    /** Name of the user who created the schedule */
    userName?: string | undefined;
    /** Email of the user who created the schedule */
    email?: string | undefined;
    /** ID of the online user who created the schedule */
    onlineUserId?: number | undefined;
    /** Formatted payment method (e.g., Visa*4242) */
    paymentMethod?: string | undefined;
    /** Date of the next pending or active instance, as ISO date "YYYY-MM-DD" */
    nextInstanceDate?: string | undefined;
    /** Date the schedule was created */
    createdDate?: Date;
    /** Business system item key for the fee */
    businessSystemItemKey?: string;
    /** Name of the page this schedule belongs to */
    pageName?: string;
    /** Reason for the schedule's current status (e.g. admin cancellation reason, validation failure description) */
    reason?: string | undefined;
    /** Scheduling display details fetched from the business system (e.g. Due Date, Balance Due) */
    details?: SchedulingDetailDto[] | undefined;
    instances?: AdminScheduledPaymentInstanceDto[];

    [key: string]: any;

    constructor(data?: IAdminScheduledPaymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.guid = _data["guid"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.totalPaymentAmount = _data["totalPaymentAmount"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.interval = _data["interval"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.onlineUserId = _data["onlineUserId"];
            this.paymentMethod = _data["paymentMethod"];
            this.nextInstanceDate = _data["nextInstanceDate"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.businessSystemItemKey = _data["businessSystemItemKey"];
            this.pageName = _data["pageName"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(SchedulingDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["instances"])) {
                this.instances = [] as any;
                for (let item of _data["instances"])
                    this.instances!.push(AdminScheduledPaymentInstanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminScheduledPaymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminScheduledPaymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["guid"] = this.guid;
        data["title"] = this.title;
        data["status"] = this.status;
        data["totalPaymentAmount"] = this.totalPaymentAmount;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["interval"] = this.interval;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["onlineUserId"] = this.onlineUserId;
        data["paymentMethod"] = this.paymentMethod;
        data["nextInstanceDate"] = this.nextInstanceDate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["businessSystemItemKey"] = this.businessSystemItemKey;
        data["pageName"] = this.pageName;
        data["reason"] = this.reason;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        if (Array.isArray(this.instances)) {
            data["instances"] = [];
            for (let item of this.instances)
                data["instances"].push(item.toJSON());
        }
        return data;
    }
}

/** Full details of a scheduled payment for admin view */
export interface IAdminScheduledPaymentDetailDto {
    /** Unique identifier */
    guid?: string;
    /** Display title of the scheduled payment */
    title?: string;
    /** Current status of the schedule */
    status?: string;
    /** Total payment amount */
    totalPaymentAmount?: number;
    /** First payment date, as ISO date "YYYY-MM-DD" */
    startDate?: string;
    /** Inclusive upper bound for scheduled instance dates, as ISO date "YYYY-MM-DD" */
    endDate?: string | undefined;
    /** Payment frequency interval */
    interval?: string;
    /** Name of the user who created the schedule */
    userName?: string | undefined;
    /** Email of the user who created the schedule */
    email?: string | undefined;
    /** ID of the online user who created the schedule */
    onlineUserId?: number | undefined;
    /** Formatted payment method (e.g., Visa*4242) */
    paymentMethod?: string | undefined;
    /** Date of the next pending or active instance, as ISO date "YYYY-MM-DD" */
    nextInstanceDate?: string | undefined;
    /** Date the schedule was created */
    createdDate?: Date;
    /** Business system item key for the fee */
    businessSystemItemKey?: string;
    /** Name of the page this schedule belongs to */
    pageName?: string;
    /** Reason for the schedule's current status (e.g. admin cancellation reason, validation failure description) */
    reason?: string | undefined;
    /** Scheduling display details fetched from the business system (e.g. Due Date, Balance Due) */
    details?: SchedulingDetailDto[] | undefined;
    instances?: AdminScheduledPaymentInstanceDto[];

    [key: string]: any;
}

export class SchedulingDetailDto implements ISchedulingDetailDto {
    /** Display label */
    label!: string;
    /** Detail value */
    value!: string;

    [key: string]: any;

    constructor(data?: ISchedulingDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SchedulingDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulingDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ISchedulingDetailDto {
    /** Display label */
    label: string;
    /** Detail value */
    value: string;

    [key: string]: any;
}

/** Details of a single scheduled payment instance */
export class AdminScheduledPaymentInstanceDto implements IAdminScheduledPaymentInstanceDto {
    /** Unique identifier; null for projected instances that have not yet been created */
    guid?: string | undefined;
    /** Sequential position of this instance */
    instanceNumber?: number;
    /** Date the payment is scheduled for, as ISO date "YYYY-MM-DD" */
    scheduledForDate?: string;
    /** Estimated payment amount */
    estimatedAmount?: number;
    /** Estimated convenience fee */
    estimatedConvenienceFee?: number;
    /** Current status of this instance */
    status?: string;
    /** Actual amount paid, if processed */
    actualAmount?: number | undefined;
    /** Actual convenience fee, if processed */
    actualConvenienceFee?: number | undefined;
    /** Identifier of the associated payment, if processed */
    paymentIdentifier?: string | undefined;
    /** Failure reason or status detail */
    message?: string | undefined;

    [key: string]: any;

    constructor(data?: IAdminScheduledPaymentInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.guid = _data["guid"];
            this.instanceNumber = _data["instanceNumber"];
            this.scheduledForDate = _data["scheduledForDate"];
            this.estimatedAmount = _data["estimatedAmount"];
            this.estimatedConvenienceFee = _data["estimatedConvenienceFee"];
            this.status = _data["status"];
            this.actualAmount = _data["actualAmount"];
            this.actualConvenienceFee = _data["actualConvenienceFee"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AdminScheduledPaymentInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminScheduledPaymentInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["guid"] = this.guid;
        data["instanceNumber"] = this.instanceNumber;
        data["scheduledForDate"] = this.scheduledForDate;
        data["estimatedAmount"] = this.estimatedAmount;
        data["estimatedConvenienceFee"] = this.estimatedConvenienceFee;
        data["status"] = this.status;
        data["actualAmount"] = this.actualAmount;
        data["actualConvenienceFee"] = this.actualConvenienceFee;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["message"] = this.message;
        return data;
    }
}

/** Details of a single scheduled payment instance */
export interface IAdminScheduledPaymentInstanceDto {
    /** Unique identifier; null for projected instances that have not yet been created */
    guid?: string | undefined;
    /** Sequential position of this instance */
    instanceNumber?: number;
    /** Date the payment is scheduled for, as ISO date "YYYY-MM-DD" */
    scheduledForDate?: string;
    /** Estimated payment amount */
    estimatedAmount?: number;
    /** Estimated convenience fee */
    estimatedConvenienceFee?: number;
    /** Current status of this instance */
    status?: string;
    /** Actual amount paid, if processed */
    actualAmount?: number | undefined;
    /** Actual convenience fee, if processed */
    actualConvenienceFee?: number | undefined;
    /** Identifier of the associated payment, if processed */
    paymentIdentifier?: string | undefined;
    /** Failure reason or status detail */
    message?: string | undefined;

    [key: string]: any;
}

/** Authorization flow that prompted the consent event. Mirrors `PaymentAuthorizationTypeEnum` in C#. Stored as the string value in the database via `EnumToStringConverter`; serialized as the string value over the wire. */
export enum PaymentAuthorizationTypeEnumDto {
    AdHoc = "AdHoc",
    SavedPaymentMethod = "SavedPaymentMethod",
    ScheduledPayment = "ScheduledPayment",
}

/** One immutable version of an authorization notice presented to users */
export class AuthorizationTextVersionDto implements IAuthorizationTextVersionDto {
    /** Surrogate key of the AuthorizationTextVersion row */
    id!: number;
    paymentMethodType!: PaymentTypeEnumDto;
    authorizationType!: PaymentAuthorizationTypeEnumDto;
    /** Exact text presented to the user. Tenant-name placeholders are resolved at version-create time; this is what was displayed and what the consent-time byte comparison validates against. */
    authorizationText!: string;
    /** True for the single current version of (PMT, AT); false for superseded or explicitly deactivated versions. */
    isActive!: boolean;
    /** When this version was created */
    createdDateUtc!: Date;
    /** Display name of the admin who created this version */
    createdByUserName?: string | undefined;
    /** When this version was deactivated (either superseded by a new active version or explicitly deactivated for an optional Credit variant); null while still active. */
    deactivatedDateUtc?: Date | undefined;

    [key: string]: any;

    constructor(data?: IAuthorizationTextVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.authorizationType = _data["authorizationType"];
            this.authorizationText = _data["authorizationText"];
            this.isActive = _data["isActive"];
            this.createdDateUtc = _data["createdDateUtc"] ? new Date(_data["createdDateUtc"].toString()) : <any>undefined;
            this.createdByUserName = _data["createdByUserName"];
            this.deactivatedDateUtc = _data["deactivatedDateUtc"] ? new Date(_data["deactivatedDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationTextVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationTextVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["paymentMethodType"] = this.paymentMethodType;
        data["authorizationType"] = this.authorizationType;
        data["authorizationText"] = this.authorizationText;
        data["isActive"] = this.isActive;
        data["createdDateUtc"] = this.createdDateUtc ? this.createdDateUtc.toISOString() : <any>undefined;
        data["createdByUserName"] = this.createdByUserName;
        data["deactivatedDateUtc"] = this.deactivatedDateUtc ? this.deactivatedDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

/** One immutable version of an authorization notice presented to users */
export interface IAuthorizationTextVersionDto {
    /** Surrogate key of the AuthorizationTextVersion row */
    id: number;
    paymentMethodType: PaymentTypeEnumDto;
    authorizationType: PaymentAuthorizationTypeEnumDto;
    /** Exact text presented to the user. Tenant-name placeholders are resolved at version-create time; this is what was displayed and what the consent-time byte comparison validates against. */
    authorizationText: string;
    /** True for the single current version of (PMT, AT); false for superseded or explicitly deactivated versions. */
    isActive: boolean;
    /** When this version was created */
    createdDateUtc: Date;
    /** Display name of the admin who created this version */
    createdByUserName?: string | undefined;
    /** When this version was deactivated (either superseded by a new active version or explicitly deactivated for an optional Credit variant); null while still active. */
    deactivatedDateUtc?: Date | undefined;

    [key: string]: any;
}

/** Payload for creating a new authorization-text version */
export class CreateAuthorizationTextVersionRequestDto implements ICreateAuthorizationTextVersionRequestDto {
    paymentMethodType!: PaymentTypeEnumDto;
    authorizationType!: PaymentAuthorizationTypeEnumDto;
    /** New authorization text. Max 10,000 characters. */
    authorizationText!: string;
    /** The id of the version the admin believed was active when they started editing. Used for optimistic-concurrency detection; mismatch indicates a concurrent admin save and triggers a typed conflict response that carries the new current version. */
    expectedPriorActiveVersionId?: number | undefined;

    [key: string]: any;

    constructor(data?: ICreateAuthorizationTextVersionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodType = _data["paymentMethodType"];
            this.authorizationType = _data["authorizationType"];
            this.authorizationText = _data["authorizationText"];
            this.expectedPriorActiveVersionId = _data["expectedPriorActiveVersionId"];
        }
    }

    static fromJS(data: any): CreateAuthorizationTextVersionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthorizationTextVersionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodType"] = this.paymentMethodType;
        data["authorizationType"] = this.authorizationType;
        data["authorizationText"] = this.authorizationText;
        data["expectedPriorActiveVersionId"] = this.expectedPriorActiveVersionId;
        return data;
    }
}

/** Payload for creating a new authorization-text version */
export interface ICreateAuthorizationTextVersionRequestDto {
    paymentMethodType: PaymentTypeEnumDto;
    authorizationType: PaymentAuthorizationTypeEnumDto;
    /** New authorization text. Max 10,000 characters. */
    authorizationText: string;
    /** The id of the version the admin believed was active when they started editing. Used for optimistic-concurrency detection; mismatch indicates a concurrent admin save and triggers a typed conflict response that carries the new current version. */
    expectedPriorActiveVersionId?: number | undefined;

    [key: string]: any;
}

/** Identifies a Teller plugin capability. Used to filter the getTellerPlugins response to only plugins that satisfy the requested capability. Mirrors Teller.Plugins.TOPluginCapability in the Teller SDK. */
export enum TOPluginCapabilityEnumDto {
    BusinessSystemItems = "BusinessSystemItems",
    ScheduledPayments = "ScheduledPayments",
}

/** Possible filters that can be applied to a search */
export enum PaymentsSearchOptionsEnumDto {
    MaxTotal = "MaxTotal",
    MinTotal = "MinTotal",
    Status = "Status",
    OneOfStatus = "OneOfStatus",
    StartDate = "StartDate",
    EndDate = "EndDate",
    HasNoEndDate = "HasNoEndDate",
}

/** A possible filter to apply to a search */
export class SearchFilterDto implements ISearchFilterDto {
    type?: PaymentsSearchOptionsEnumDto;
    value?: string;

    [key: string]: any;

    constructor(data?: ISearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

/** A possible filter to apply to a search */
export interface ISearchFilterDto {
    type?: PaymentsSearchOptionsEnumDto;
    value?: string;

    [key: string]: any;
}

/** Settings used for searching/filtering a list of payments */
export class SearchSettingsDto implements ISearchSettingsDto {
    filters!: SearchFilterDto[];
    /** A string to search by */
    search?: string;
    /** The column that is being sorted by currently, optional, null if not provided */
    sortColumn?: string;
    /** The direction to sort by. Defaults to ascending */
    sortDirection?: string;
    /** How many results to return per page loaded */
    pageSize!: number;
    /** The index of which page to load */
    pageIndex!: number;

    [key: string]: any;

    constructor(data?: ISearchSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(SearchFilterDto.fromJS(item));
            }
            this.search = _data["search"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
        }
    }

    static fromJS(data: any): SearchSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["search"] = this.search;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        return data;
    }
}

/** Settings used for searching/filtering a list of payments */
export interface ISearchSettingsDto {
    filters: SearchFilterDto[];
    /** A string to search by */
    search?: string;
    /** The column that is being sorted by currently, optional, null if not provided */
    sortColumn?: string;
    /** The direction to sort by. Defaults to ascending */
    sortDirection?: string;
    /** How many results to return per page loaded */
    pageSize: number;
    /** The index of which page to load */
    pageIndex: number;

    [key: string]: any;
}

/** Status of a payment. */
export enum PaymentStatusEnumDto {
    PreProcessing = "PreProcessing",
    Processing = "Processing",
    Processed = "Processed",
    ProcessingFailed = "ProcessingFailed",
    Failed = "Failed",
    Posting = "Posting",
    Posted = "Posted",
    PostingFailed = "PostingFailed",
    PendingReview = "PendingReview",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Finalized = "Finalized",
}

/** Supported payment method types */
export enum PaymentMethodTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
    Undetermined = "Undetermined",
}

/** Digital wallet flavor for a wallet-originated payment. Mirrors the backend `DigitalWalletType` domain enum on the wire as a string (NSwag-style string enum) so the same generated type is reusable across portals. */
export enum DigitalWalletTypeEnumDto {
    GooglePay = "GooglePay",
    ApplePay = "ApplePay",
}

/** A brief summary of bare minimum details for a cart in the online portal */
export class PaymentSummaryDto implements IPaymentSummaryDto {
    /** Unique value for the payment used in the payment gateway */
    paymentIdentifier?: string;
    status!: PaymentStatusEnumDto;
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    /** The last time that this cart was modified (most useful for payments that are incomplete) */
    lastChangeDate?: Date;
    /** Total price that was paid for this cart */
    total?: number;
    /** Raw summed total of all the items in the cart (prior to fees) */
    subtotal?: number;
    /** Total value of the convenience fee(s) that were paid on the cart */
    convenienceFee?: number;
    /** The type and last 4 digits of the payment method used */
    paymentMethod?: string;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Wallet type when the payment was made via a digital wallet. Null for
regular card / eCheck payments. Surfaces in admin views so support
can distinguish wallet-originated payments from typed-card payments
at a glance (relevant for chargeback investigation, dispute handling,
and customer-service context).
 */
    digitalWalletType?: DigitalWalletTypeEnumDto;
    /** The key to determine which configuration was used */
    configKey?: string;
    /** Scheduled date if this payment belongs to a scheduled payment, as ISO date "YYYY-MM-DD" */
    scheduledDate?: string;
    /** Item title from the parent scheduled payment */
    scheduledItemTitle?: string;
    /** Status of the scheduled payment instance (Pending, Active, Processing, etc.) */
    scheduledInstanceStatus?: string;
    /** GUID of the parent scheduled payment for navigation */
    scheduledPaymentGuid?: string;
    /** GUID of the specific scheduled payment instance */
    scheduledInstanceGuid?: string;

    [key: string]: any;

    constructor(data?: IPaymentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.status = _data["status"];
            this.tellerReceiptNumber = _data["tellerReceiptNumber"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.lastChangeDate = _data["lastChangeDate"] ? new Date(_data["lastChangeDate"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.subtotal = _data["subtotal"];
            this.convenienceFee = _data["convenienceFee"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.digitalWalletType = _data["digitalWalletType"];
            this.configKey = _data["configKey"];
            this.scheduledDate = _data["scheduledDate"];
            this.scheduledItemTitle = _data["scheduledItemTitle"];
            this.scheduledInstanceStatus = _data["scheduledInstanceStatus"];
            this.scheduledPaymentGuid = _data["scheduledPaymentGuid"];
            this.scheduledInstanceGuid = _data["scheduledInstanceGuid"];
        }
    }

    static fromJS(data: any): PaymentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["status"] = this.status;
        data["tellerReceiptNumber"] = this.tellerReceiptNumber;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["lastChangeDate"] = this.lastChangeDate ? this.lastChangeDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["subtotal"] = this.subtotal;
        data["convenienceFee"] = this.convenienceFee;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentMethodType"] = this.paymentMethodType;
        data["digitalWalletType"] = this.digitalWalletType;
        data["configKey"] = this.configKey;
        data["scheduledDate"] = this.scheduledDate;
        data["scheduledItemTitle"] = this.scheduledItemTitle;
        data["scheduledInstanceStatus"] = this.scheduledInstanceStatus;
        data["scheduledPaymentGuid"] = this.scheduledPaymentGuid;
        data["scheduledInstanceGuid"] = this.scheduledInstanceGuid;
        return data;
    }
}

/** A brief summary of bare minimum details for a cart in the online portal */
export interface IPaymentSummaryDto {
    /** Unique value for the payment used in the payment gateway */
    paymentIdentifier?: string;
    status: PaymentStatusEnumDto;
    /** Receipt Number in Teller */
    tellerReceiptNumber?: string;
    /** The date/time that this cart payment was done */
    paymentDate?: Date;
    /** The last time that this cart was modified (most useful for payments that are incomplete) */
    lastChangeDate?: Date;
    /** Total price that was paid for this cart */
    total?: number;
    /** Raw summed total of all the items in the cart (prior to fees) */
    subtotal?: number;
    /** Total value of the convenience fee(s) that were paid on the cart */
    convenienceFee?: number;
    /** The type and last 4 digits of the payment method used */
    paymentMethod?: string;
    paymentMethodType?: PaymentMethodTypeEnumDto;
    /** Wallet type when the payment was made via a digital wallet. Null for
regular card / eCheck payments. Surfaces in admin views so support
can distinguish wallet-originated payments from typed-card payments
at a glance (relevant for chargeback investigation, dispute handling,
and customer-service context).
 */
    digitalWalletType?: DigitalWalletTypeEnumDto;
    /** The key to determine which configuration was used */
    configKey?: string;
    /** Scheduled date if this payment belongs to a scheduled payment, as ISO date "YYYY-MM-DD" */
    scheduledDate?: string;
    /** Item title from the parent scheduled payment */
    scheduledItemTitle?: string;
    /** Status of the scheduled payment instance (Pending, Active, Processing, etc.) */
    scheduledInstanceStatus?: string;
    /** GUID of the parent scheduled payment for navigation */
    scheduledPaymentGuid?: string;
    /** GUID of the specific scheduled payment instance */
    scheduledInstanceGuid?: string;

    [key: string]: any;
}

export class UserProfileDto implements IUserProfileDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Unique user ID */
    onlineUserId?: number;
    /** The user's email */
    email?: string;
    /** The user's email is verified */
    emailVerified?: boolean;
    /** The user's name */
    name?: string;
    /** The user's phone number */
    phoneNumber?: string;
    /** The user's phone number is verified */
    phoneNumberVerified?: boolean;

    [key: string]: any;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.identityProviderUserId = _data["identityProviderUserId"];
            this.onlineUserId = _data["onlineUserId"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberVerified = _data["phoneNumberVerified"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["identityProviderUserId"] = this.identityProviderUserId;
        data["onlineUserId"] = this.onlineUserId;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberVerified"] = this.phoneNumberVerified;
        return data;
    }
}

export interface IUserProfileDto {
    /** Identity server user id */
    identityProviderUserId?: string;
    /** Unique user ID */
    onlineUserId?: number;
    /** The user's email */
    email?: string;
    /** The user's email is verified */
    emailVerified?: boolean;
    /** The user's name */
    name?: string;
    /** The user's phone number */
    phoneNumber?: string;
    /** The user's phone number is verified */
    phoneNumberVerified?: boolean;

    [key: string]: any;
}

/** Summary of a payment with who made the payment. Typically used in the Admin portal for rendering a list */
export class PaymentOverviewDto implements IPaymentOverviewDto {
    summary!: PaymentSummaryDto;
    /** User who made the payment */
    user?: UserProfileDto;
    /** The email associated with the payment. Should only be present for anonymous payments */
    email?: string;

    [key: string]: any;

    constructor(data?: IPaymentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new PaymentSummaryDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.summary = _data["summary"] ? PaymentSummaryDto.fromJS(_data["summary"]) : new PaymentSummaryDto();
            this.user = _data["user"] ? UserProfileDto.fromJS(_data["user"]) : <any>undefined;
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PaymentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

/** Summary of a payment with who made the payment. Typically used in the Admin portal for rendering a list */
export interface IPaymentOverviewDto {
    summary: PaymentSummaryDto;
    /** User who made the payment */
    user?: UserProfileDto;
    /** The email associated with the payment. Should only be present for anonymous payments */
    email?: string;

    [key: string]: any;
}

/** Results of filtering payments */
export class FilteredPaymentsResponseDto implements IFilteredPaymentsResponseDto {
    results?: PaymentOverviewDto[];
    /** The total number of payments returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;

    constructor(data?: IFilteredPaymentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PaymentOverviewDto.fromJS(item));
            }
            this.totalResults = _data["totalResults"];
        }
    }

    static fromJS(data: any): FilteredPaymentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredPaymentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalResults"] = this.totalResults;
        return data;
    }
}

/** Results of filtering payments */
export interface IFilteredPaymentsResponseDto {
    results?: PaymentOverviewDto[];
    /** The total number of payments returned by this search (to be used for pagination) */
    totalResults?: number;

    [key: string]: any;
}

/** Status of a cart. */
export enum CartStatusEnumDto {
    Open = "Open",
    CheckingOut = "CheckingOut",
    Processing = "Processing",
    Finalized = "Finalized",
    Closed = "Closed",
}

/** What is the currently active payment integration */
export enum PaymentIntegrationEnumDto {
    Demo = "Demo",
    Nic = "Nic",
    Datacap = "Datacap",
    Celero = "Celero",
    BridgePay = "BridgePay",
    Elavon = "Elavon",
    PointAndPay = "PointAndPay",
    CyberSource = "CyberSource",
    WellsFargo = "WellsFargo",
    Fis = "Fis",
    Paymentus = "Paymentus",
    InvoiceCloud = "InvoiceCloud",
    Govolution = "Govolution",
    MSB = "MSB",
    Fiserv = "Fiserv",
    LexisNexis = "LexisNexis",
    Generic = "Generic",
}

/** Active authorization-text version data returned to the frontend for display at consent time. Returned by GET /authorization-text/active for the requested (paymentMethodType, authorizationType); also echoed inline in error responses when a stale-version rejection happens, so the consent component can re-render onto the new active version without a full page refresh. */
export class ActiveAuthorizationTextDto implements IActiveAuthorizationTextDto {
    /** Id of the active AuthorizationTextVersion. */
    versionId!: number;
    /** Exact text to display to the user. The client must echo this verbatim
back on the consent submission so the server can hash-compare against
its stored hash.
 */
    text!: string;

    [key: string]: any;

    constructor(data?: IActiveAuthorizationTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.versionId = _data["versionId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ActiveAuthorizationTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAuthorizationTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["versionId"] = this.versionId;
        data["text"] = this.text;
        return data;
    }
}

/** Active authorization-text version data returned to the frontend for display at consent time. Returned by GET /authorization-text/active for the requested (paymentMethodType, authorizationType); also echoed inline in error responses when a stale-version rejection happens, so the consent component can re-render onto the new active version without a full page refresh. */
export interface IActiveAuthorizationTextDto {
    /** Id of the active AuthorizationTextVersion. */
    versionId: number;
    /** Exact text to display to the user. The client must echo this verbatim
back on the consent submission so the server can hash-compare against
its stored hash.
 */
    text: string;

    [key: string]: any;
}

export class ErrorDto implements IErrorDto {
    /** Error message to display to the user */
    errorMessage!: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber!: string;
    /** Error def identifying the error */
    errorDef!: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;
    /** For `errorDef = "AuthorizationVersionStale"` rejections only: the new
currently-active authorization text. The consent component re-renders
onto this version inline (deviation #4), allowing the user to re-confirm
without losing other form state. Absent for all other error responses. */
    activeAuthorizationText?: ActiveAuthorizationTextDto;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.errorMessage = _data["errorMessage"];
            this.errorNumber = _data["errorNumber"];
            this.errorDef = _data["errorDef"];
            this.errorDetails = _data["errorDetails"];
            this.prompt = _data["prompt"];
            this.activeAuthorizationText = _data["activeAuthorizationText"] ? ActiveAuthorizationTextDto.fromJS(_data["activeAuthorizationText"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["errorMessage"] = this.errorMessage;
        data["errorNumber"] = this.errorNumber;
        data["errorDef"] = this.errorDef;
        data["errorDetails"] = this.errorDetails;
        data["prompt"] = this.prompt;
        data["activeAuthorizationText"] = this.activeAuthorizationText ? this.activeAuthorizationText.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorDto {
    /** Error message to display to the user */
    errorMessage: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber: string;
    /** Error def identifying the error */
    errorDef: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;
    /** For `errorDef = "AuthorizationVersionStale"` rejections only: the new
currently-active authorization text. The consent component re-renders
onto this version inline (deviation #4), allowing the user to re-confirm
without losing other form state. Absent for all other error responses. */
    activeAuthorizationText?: ActiveAuthorizationTextDto;

    [key: string]: any;
}

export enum ProcessECheckRequestDtoAccountType {
    Checking = "Checking",
    Savings = "Savings",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class InternalApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isInternalApiException = true;

    static isInternalApiException(obj: any): obj is InternalApiException {
        return obj.isInternalApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new InternalApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}